import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useLayoutEffect,
} from "react";
import LeftNavMenu from "../common/Navbar";
import "../../styles/Unclaimed-CME-Dashboard.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import API_URL, {
  OpportunitiesLink,
  ReportURL,
  AuthorizationCredentials,
  MERGE_FILE_ENDPOINT_URL,
  EXCLUDED_LIST_OF_ACTIVITY_TYPES,
  CMEAccountURL as CMEAccountURLForProfile
} from "../../config/config";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {
  Typography,
  Snackbar,
  Link,
  Stack,
  InputAdornment,
  TextField,
  Switch,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import Button from "@mui/material/Button";
import apiProfiles from "../../api-operation";
import DeleteTopic from "../DeleteTopic";
import Alert from "../common/Alert";
import { v4 as uuid } from "uuid";
import EmptyUnclaimedImg from "../../images/UnclaimedEmptyList.png";
import EmptyActivityImg from "../../images/ActivityEmpty.png";
import { ExpandMore, ExpandLess, HighlightOff } from "@mui/icons-material";
import { contactContext } from "../../context/contactContext";
import { userContext } from "../../context/userContext";
import { BrowserRouter, useHistory, Prompt } from "react-router-dom";
import Container from "../CMEProfileManagement/ModalContainer";
import { PDFDocument } from "pdf-lib";
import apiUsers from "../../api-operation";
import DeleteSelfReportedActivity from "../DeleteSelfReportedActivity";
import { promiseContext } from "../../context/promiseContext";
import { FileUploadOutlined } from "@mui/icons-material";
import axios from "axios";
import DeleteCMEActivity from "../DeleteCMEActivity";
import DeleteSelfReportedBlob from "../DeleteSelfReportedBlob";
import { GetRoundUpValue, SetCursorToTop } from "../../utils/utils";
import { isNonMember, shouldShowPhysicianToggle as shouldShowToggle, needsProfessionalStatusAttestation } from '../../utils/membershipUtils';
import { useQueryClient } from "@tanstack/react-query";
import SearchIcon from "@mui/icons-material/Search";
import {
  GetUnclaimedData,
  GetClaimedData,
  GetTopicData,
  GetActivityTypeData,
} from "../../utils/cache";
import JSZip from "jszip";
import download from "downloadjs";
import { useLocation } from "react-router-dom";
import LearnerProfileHeader from "../LearnerProfileHeader";
import { MedicalLicense } from "../LicensesSection";
import { Modal as PARSModal } from "../CMEProfileManagement/ModalPopup";
import shortid from "shortid";
import MyDatePicker from "./MyDatePicker";
import LeavePageDialog from "./LeavePageDialog";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import { FEATURE_Phase_1_MERGE_CME, FEATURE_ACCREDITATION_ENABLED, SelfReported_CME_Tracking_Status_Id, Finalized_CME_Tracking_Status_Id, None_Topic_Id, ACCREDITATION_SITES, enabledAccreditationSiteKeys, isAccreditationSiteEnabled, ACCREDITATION_MESSAGES } from "../../config/config";


var moment = require("moment");

// Module-level guard: survives component remount/unmount within the same browser session.
// Keyed by contactId so admin-proxy switching between users is handled correctly.
// A Map entry with a timestamp < 24h means "already shown today for this user — skip".
const deadlineWarningShownThisSession = new Map<string, number>();

const isLiveActivity = (typeName: string | null | undefined): boolean =>
  !!(typeName && (
    typeName.toUpperCase().includes('LIVE') ||
    typeName.trim().toLowerCase() === 'regularly scheduled series'
  ));

interface SiteAlert {
  message: string;
  severity: 'success' | 'error';
}

// The /pars/learner/save response now aggregates outcomes across every accreditation
// site the learner's licenses route to (e.g. a TX license can go to both PARS and CE
// Broker for the same claim) — each site gets its own independent alert (own banner,
// own color) rather than one combined message assuming a single ACCME outcome. A site
// with no entries in `results` (the learner's licenses never routed to it) gets no
// entry here at all, so its banner simply never opens.
const buildSiteAccreditationAlerts = (results: any[]): Record<string, SiteAlert> => {
  // `results` holds one entry per (certificate, site) pair — a site appears more than
  // once whenever the activity has multiple licenses/topics routed to it. Aggregate
  // per site (any rejection => that site is Rejected) instead of taking the first
  // entry seen, which could report a site as Accepted while a later certificate for
  // that same site was actually rejected.
  const siteOrder: string[] = [];
  const siteRejected = new Map<string, boolean>();
  (results || []).forEach((r) => {
    const site = r?.siteName ?? r?.SiteName;
    const status = r?.statusCode ?? r?.StatusCode;
    if (!site || !status) return;
    if (!siteRejected.has(site)) {
      siteOrder.push(site);
      siteRejected.set(site, false);
    }
    if (String(status).trim().toUpperCase() !== 'ACCEPTED') {
      siteRejected.set(site, true);
    }
  });

  const alerts: Record<string, SiteAlert> = {};
  siteOrder.forEach((site) => {
    // Site disabled in ACCREDITATION_SITES for this environment — drop its result rather than
    // falling back to the raw site name, so a site hidden from the UI can never surface a
    // banner even if the API still returns results for it.
    if (!isAccreditationSiteEnabled(site)) return;
    const label = ACCREDITATION_SITES[site].label;
    alerts[site] = siteRejected.get(site)
      ? { message: ACCREDITATION_MESSAGES.claimRejected(label), severity: 'error' }
      : { message: ACCREDITATION_MESSAGES.claimAccepted(label), severity: 'success' };
  });
  return alerts;
};

const isActivityExpired = (typeName: string | null | undefined, endDate: string | null | undefined): boolean => {
  if (isLiveActivity(typeName) || !endDate) return false;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const end = new Date(endDate); end.setHours(0, 0, 0, 0);
  return end < today;
};

const showDeadlineDateRed = (typeName: string | null | undefined, endDate: string | null | undefined): boolean => {
  if (isLiveActivity(typeName) || !endDate) return false;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const end = new Date(endDate); end.setHours(0, 0, 0, 0);
  const daysRemaining = Math.floor((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  return daysRemaining <= 30;
};

// Boards a claimed activity has actually been accepted by, read straight off CME_Tracking's own
// IsACCMEAccreditationAccepted / IsCEBrokerAccreditationAccepted flags (set/cleared server-side in
// cmeparslearner.ts) rather than aggregating CME_Accreditation_Submissions rows — those flags
// survive that table's nightly archival, unlike the submission rows themselves. Which flags are
// read comes from ACCREDITATION_SITES in declaration order, so a site switched off there never
// counts, even on rows claimed while it was still live.
const getAcceptedSiteKeys = (item: any): string[] =>
  enabledAccreditationSiteKeys().filter((key) => item?.[ACCREDITATION_SITES[key].acceptedFlag]);

const getAcceptedBoardsLabel = (item: any): string | null => {
  const boards = getAcceptedSiteKeys(item).map((key) => ACCREDITATION_SITES[key].boardBadge);
  return boards.length > 0 ? boards.join(', ') : null;
};

const getDaysRemaining = (endDate: string | null | undefined): number => {
  if (!endDate) return 0;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const end = new Date(endDate); end.setHours(0, 0, 0, 0);
  return Math.floor((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
};

let msg = "", errorMsg = "",
  claimCMEHours = "0",
  emptyBlobDetails = "";
let innerHeight = 350;
let addedTopicInnerHeight = 400;
let selfReportedInnerHeight = 610;
let selectedABEMTransRecordList: any[] = [];

const allowedExtensions = ["png", "jpeg", "jpg", "pdf", "doc", "docx"];
const allowedTypes = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];



export function ClaimUnclaimCMEDashboard(props: any) {
  const { claimeStyles, showSpinner, propsSource, spinner, recordAction = 'add' } = props;
  const [pdfFile, setPdfFIle] = useState<File | string>("");
  const [pdfURL, setPdfURL] = useState("");

  const [isIFrameVisible, setIsIFrameVisible] = useState(true);
  //List of Topic and Hours details will be added in CME Tracking Details
  const [topicInfo, setTopicInfo] = React.useState<iTopicInfo[]>([]);

  //Existing Topic List which will be showin in the dropdown
  const [cmeTopicList, setCmeTopicList] = React.useState<any[] | []>([]);
  const [innerHeightAddTopicDiv, setInnerHeightAddTopicDiv] =
    useState(innerHeight);
  //used to set the cursor to the row which is expanded
  const [listIndex, setListIndex] = useState(-1);
  //used to set the custor to the row Cancel clicked
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const [disableAddTranscriptButton, setDisableAddTranscriptButton] =
    useState(true);
  // const [claimCMEHours, setClaimCMEHours] = useState<Number>(0);
  const [remainingHoursToClaim, setRemainingHoursToClaim] = useState<Number>(0);
  const [claimedExistingCMEHours, setClaimedExistingCMEHours] =
    useState<Number>(0);
  const [claimCMETrackingId, setClaimCMETrackingId] = useState<string>("");
  const [currentCMEActivityId, setCurrentCMEActivityId] = useState<string | null>(null);
  const [currentActivityTypeName, setCurrentActivityTypeName] = useState<string>("");
  const [currentActivityEndDate, setCurrentActivityEndDate] = useState<string | null>(null);
  const [currentTrackingStatusId, setCurrentTrackingStatusId] = useState<Number>(0);
  const [approvedByAcep, setApprovedByAcep] = useState<boolean>(false);
  const [approvedByAMA, setApprovedByAMA] = useState<boolean>(false);
  const [showLeftHandTopicHoursValid, setShowLeftHandTopicHoursValid] =
    useState<boolean>(false);
  const [claimAddTopicHours, setclaimAddTopicHours] = useState<Number>(0);
  const [current, setCurrent] = useState("");
  const [showData, setShowData] = useState(false);
  const [sortResult, setSortResult] = useState(false);
  const [isNavExpanded, setIsNavExpanded] = React.useState(false);
  const [openAlertMsg, setOpenAlertMsg] = React.useState(false);
  // Independent alert state per accreditation site so PARS and CE Broker outcomes never
  // get flattened into one banner/color — see buildSiteAccreditationAlerts.
  const [parsAlertOpen, setParsAlertOpen] = React.useState(false);
  const [parsAlertMsg, setParsAlertMsg] = React.useState('');
  const [parsAlertSeverity, setParsAlertSeverity] = React.useState<'success' | 'error'>('success');
  const [ceBrokerAlertOpen, setCeBrokerAlertOpen] = React.useState(false);
  const [ceBrokerAlertMsg, setCeBrokerAlertMsg] = React.useState('');
  const [ceBrokerAlertSeverity, setCeBrokerAlertSeverity] = React.useState<'success' | 'error'>('success');
  // Ordered toast stack for the two accreditation banners, newest-first (index 0 = bottom-most,
  // closest to the corner). Both banners anchor at the same bottom-left position; a currently-open
  // banner shifts up by one slot whenever a newer one opens beneath it, and shifts back down when
  // an older/other banner above it closes.
  const [accreditationToastOrder, setAccreditationToastOrder] = React.useState<string[]>([]);
  const ACCREDITATION_TOAST_GAP_PX = 70; // vertical clearance per stacked banner
  const pushAccreditationToast = (key: string) => {
    setAccreditationToastOrder((prev) => [key, ...prev.filter((k) => k !== key)]);
  };
  const popAccreditationToast = (key: string) => {
    setAccreditationToastOrder((prev) => prev.filter((k) => k !== key));
  };
  const accreditationToastOffsetPx = (key: string): number => {
    const index = accreditationToastOrder.indexOf(key);
    return index >= 0 ? index * ACCREDITATION_TOAST_GAP_PX : 0;
  };
  const [cmeTrackingDetails, setCMETrackingDetails] = useState<any[] | []>([]);
  const [cpyCMETrackingDetails, setCpyCMETrackingDetails] = useState<
    any[] | []
  >([]);
  const [searchListData, setSearchListData] = useState<any[] | []>([]);

  //For checkbox
  const [enableTranscript, setEnableTranscript] = React.useState("#1976D2");
  const [deleteTranscriptRecords, setDeleteTranscriptRecords] = useState("");
  const [headerCheckUncheckBox, setHeaderCheckUnchekBox] = useState(false);

  //This is for when uncheck header checkbox when one of child checkbox unchecked
  //so only header checkbox should unchecked
  const [handleHeaderCheckEvent, setHandleHeaderCheckEvent] = useState(true);
  //For Self Reported Activity
  const [showSelfReportedActivity, setShowSelfReportedActivity] =
    useState(false);
  const [disableReportButtons, setDisableReportButtons] = useState(true);
  const [searchString, setSearchString] = useState("");
  const [isNonPhysician, setIsNonPhysician] = useState<boolean>(false);
  const [showPhysicianToggle, setShowPhysicianToggle] = useState<boolean>(false);
  const [hasAttestedThisSession, setHasAttestedThisSession] = useState<boolean>(false);
  const [currentSessionNonPhysician, setCurrentSessionNonPhysician] = useState<boolean | null>(null);

  //For Filters
  const [toShowSelectFiltersDiv, setToShowSelectFiltersDiv] = useState(false);
  const [toShowSelectFiltersDateRange, setToShowSelectFiltersDateRange] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState([{ label: "" }]);
  const [cmeActivityTypeList, setcmeActivityTypeList] = React.useState<
    any[] | []
  >([{ Id: -1, Name: "" }]);
  const [filterdateInput, setfilterdateInput] = useState("");
  const [filterdateRangeStartDate, setfilterdateRangeStartDate] = useState("");
  const [filterdateRangeEndDate, setfilterdateRangeEndDate] = useState("");
  const [filteractivityTypeInput, setfilteractivityTypeInput] = useState("");
  const [filtertopicInput, setfiltertopicInput] = useState("");
  const [filteraccrediationsourceInput, setfilteraccrediationsourceInput] =
    useState("");

  //Show Hide Wait Indicators using below state
  const [pageWaitIndicator, setPageWaitIndicator] = useState(false);

  //For Certificate Upload
  const [selectedfile, setSelectedFile] = React.useState("");
  const [UploadedCertificateUrl, setUploadedCertificateUrl] =
    React.useState("");

  const [formDirty, setFormDirty] = useState(false);
  const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
  const pendingCancelRef = useRef<(() => void) | null>(null);

  const [
    lstSelfReportedNotAvailableCertificates,
    setLstSelfReportedNotAvailableCertificates,
  ] = useState("");
  const [bDisableExportCertButton, setDisableExportCertButton] = useState(true);
  const [bToShowExportCertButton, setToShowExportCertButton] = useState(false);
  const inputElement = React.useRef<any>();
  const [invalidFileMessage, setInvalidFileMessage] = useState(false);
  // Use an object to maintain the column sort order
  const [order, setOrder] = useState({ Date: "asc", Name: "asc" });
  const [updateAdminContact, setupdateAdminContact] = useState(false);

  // Create a reference to the hidden file input element
  const history = useHistory();
  const location = useLocation();
  const { from } = (location.state as { contact: any; from: string }) || {};

  let buffer1Data = "";
  let buffer2Data = "";
  let contactData: any;


  const { contactObject, updateContactInfo, updatePARSConsent, updateDeadlineWarningLastShown, isLoading: isContactLoading } = useContext(contactContext);
  const queryClient = useQueryClient();

  //For Self Reported Edit Activity
  const [currentActivity, setCurrentActivity] = useState<any>("");
  const handleActivityNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCurrentActivity(event.target.value);
    setFormDirty(true);
  };

  const [currentDate, setCurrentDate] = useState("");
  const handleNewDateChange = (date: any) => {
    setCurrentDate(date.toString());
    setFormDirty(true);
  };

  function convertToMaterialUIDateFormat(inputDate: any) {
    const parts = inputDate.split("/");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[0].padStart(2, "0")}-${parts[1].padStart(
        2,
        "0"
      )}`;
    }
    return "";
  }

  const [currentActivitytype, setCurrentActivityType] = useState<any>("");
  const handleActivityType = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentActivityType(event.target.value);
    setFormDirty(true);
  };

  const [inputModified, setInputModified] = useState("");
  // Event handler for Activity Type
  const [activityDetails, setActivityDetails] =
    React.useState<tActivityDetails>({
      Id: uuid(),
      Name: "",
      Description: "",
      CompletionDate: "",
      MaxHours: "0",
      ClaimedHours: "0",
      CertificateUrl: "",
      CME_Activity_Id: null,
      CME_ActivityType_Id: "",
      CME_Contact_Id: "-1",
      CME_Tracking_Status_Id: SelfReported_CME_Tracking_Status_Id,
    });

  //End Self Reported Edit Activity
  let promiseValue = React.useContext(promiseContext) as PromiseType;

  let userObject = useContext(userContext);

  let userData = userObject.User;
  //check user is admin or not
  let isAdmin: boolean = userData.acepMemberStatus === 2 ? true : false;
  //let isAdmin:boolean = userData.acepMemberStatus === 2 ? false : false;

  // contactObject is the only source of truth for who is being viewed. contactContext loads it
  // from ?acepid=, which survives a refresh and a hand-edited URL; the router state below does
  // not. The admin-dashboard row carried in that state is only a partial record (name, acepid,
  // job title — no address, membership status, NPI or consent), so seeding the context from it
  // painted the header with half a learner and let the rest fall back to the admin's own data.
  contactData = contactObject.Contact;

  const isMDorDO: boolean = (() => {
    const hasMDorDO = (val: string) => (val || '').toUpperCase().split(/[\s,]+/).some(d => d === 'MD' || d === 'DO');
    return hasMDorDO(contactData?.professionaldesignation) || hasMDorDO(contactData?.jobtitle);
  })();

  //For Unclaimed, set true
  //For Transcript, set false
  const props_Input =
    propsSource === "Unclaimed"
      ? true
      : propsSource === "Transcript"
        ? false
        : "";

  // Arriving from the admin dashboard means a different learner than whatever the query cache
  // holds. Dropping those entries here (an effect, not the render body — this mutates the shared
  // QueryClient and the contact provider) guarantees it happens before the new learner's data
  // can be read from a stale entry.
  useEffect(() => {
    if (from !== "AdminDashboard" || updateAdminContact) return;
    removeQueriesForAdmin();
    setupdateAdminContact(true);
    // removeQueriesForAdmin is a stable function declaration in this component
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, updateAdminContact]);

  //For Left Nav Height
  const ref = useRef<HTMLInputElement>(null);
  const [height, setHeight] = useState(0);
  const [loadNavHeight, setLoadNavHeight] = useState(false);

  const { data: trackingAPIData, isLoading: trackingAPICalled } =
    propsSource === "Unclaimed"
      ? GetUnclaimedData(contactData?.contactid)
      : GetClaimedData(contactData?.contactid);
  const { data: topicAPIData, isLoading: topicAPICalled } = GetTopicData();
  const { data: activityTypeAPIData, isLoading: activityTypeAPICalled } =
    GetActivityTypeData();

  //This is for zip file creation
  const [zipFilesToGenerate, setZipFilesToGenerate] = useState(new JSZip());

  let commaSeperatedURLToGenerateZIP: FileData[] = [];
  interface FileData {
    fileUrl: string;
    fileName: string;
  }

  useLayoutEffect(() => {
    var HomePagebackgroundHeight =
      document.body.getElementsByClassName("HomePagebackground")[0]; // Assuming there's only one element with class 'HomePagebackground'
    var currentHeight = HomePagebackgroundHeight.clientHeight; // Get the current height of the element
    var newHeight = currentHeight + 120;
    setHeight(newHeight);
    setLoadNavHeight(false);
  }, [loadNavHeight]);

  // Whoever is being viewed has changed (proxy switch, ?acepid= edited, sign-in resolving).
  // The grid keeps its own copy of the rows, so drop it here rather than waiting for the next
  // learner's data to arrive — otherwise the previous learner's activities stay on screen, and
  // with an empty contact id the queries are disabled so nothing would overwrite them.
  useEffect(() => {
    setCMETrackingDetails([]);
    setCpyCMETrackingDetails([]);
    setSearchListData([]);
    setShowData(false);
  }, [contactData?.contactid]);

  useEffect(() => {
    getCMETopicList();
    getActivityTypeList();
    getCMETrackingUnclaimedRecords();
  }, [trackingAPIData, topicAPIData, activityTypeAPIData]);

  useEffect(() => {
    if (!formDirty) return;
    const handler = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ''; };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [formDirty]);

  //Set the cursor to the expanded row
  useEffect(() => {
    if (listIndex != -1) {
      SetCursorToTop("list_row_" + listIndex);
    }
    setListIndex(-1);
  }, [listIndex]);
  //Set the cursor to the expanded row
  useEffect(() => {
    if (selectedRowIndex != -1) {
      // For iPad, set the cursor to the top of the row
      setTimeout(() => {
        console.log('This message will be logged after 1 second');
        SetCursorToTop("list_row_" + selectedRowIndex);
      }, 500);
    }
    setSelectedRowIndex(-1);
  }, [selectedRowIndex]);

  // Check if physician toggle should be shown
  // BUSINESS RULE: Only show for NON-MEMBERS who are NOT ABEM CERTIFIED
  // This should match EXACTLY the same logic as shouldShowProfessionalStatusPopup
  const shouldShowPhysicianToggle = (): boolean => {
    return shouldShowToggle(contactData);
  };

  // Initialize IsNonPhysician state and toggle visibility from contactData
  useEffect(() => {
    // Reset visibility state first
    setShowPhysicianToggle(false);
    // Reset session attestation state when contact data changes
    setHasAttestedThisSession(false);

    // Wait for valid contactData
    if (!contactData?.acepid || contactData?.acepMemberStatus === undefined || contactData?.acepMemberStatus === null) {
      return;
    }

    // Only show toggle when all API calls are complete
    const allDataLoaded = !trackingAPICalled && !topicAPICalled && !activityTypeAPICalled;
    if (!allDataLoaded) {
      return;
    }

    // Check if user should see the toggle using current contactData
    const shouldShow = shouldShowPhysicianToggle();
    if (shouldShow) {
      setShowPhysicianToggle(true);
      // Initialize toggle state from database
      if (contactData?.IsNonPhysician !== undefined) {
        setIsNonPhysician(contactData.IsNonPhysician);
      }
    }
  }, [trackingAPICalled, topicAPICalled, activityTypeAPICalled, contactData?.acepMemberStatus, contactData?.isABEMCertified, contactData?.acepid, contactData?.sempaMemberStatus, contactData?.IsNonPhysician]);

  // Handle IsNonPhysician toggle change
  const handleIsNonPhysicianToggle = async (selectedStatus: string): Promise<boolean> => {
    const newValue = selectedStatus === 'healthcare'; // 'physician' = false (not non-physician), 'healthcare' = true (is non-physician)

    try {
      // Update the contact data via API
      apiProfiles.url = `cmecontacts/${contactData.contactid}`;
      const currentDate = new Date().toISOString();
      const updateData = {
        IsNonPhysician: newValue,
        SelfAttestationUpdatedAt: currentDate
      };

      await apiProfiles.put(updateData);

      // Update the context data
      const updatedContactData = {
        ...contactData,
        IsNonPhysician: newValue,
        SelfAttestationUpdatedAt: currentDate
      };
      updateContactInfo(updatedContactData);

      // Update local state after successful API call and context update
      setIsNonPhysician(newValue);

      // Return the new value so it can be used immediately
      return newValue;

    } catch (error) {
      console.error("Error updating IsNonPhysician:", error);
      // No need to revert state since we didn't update it yet
      return isNonPhysician; // Return current state value on error
    }
  };

  // Check if professional status attestation is required
  const shouldShowProfessionalStatusPopup = (): boolean => {
    // BUSINESS RULE: Only for NON-MEMBERS who are NOT ABEM CERTIFIED
    // Members and ABEM certified users NEVER need to attest

    if (!needsProfessionalStatusAttestation(contactData)) {
      return false;
    }

    // If user has already attested in this session, don't show popup again
    if (hasAttestedThisSession) {
      return false;
    }

    // Check if they haven't attested yet - show popup if they haven't attested
    const hasAttested = contactData?.SelfAttestationUpdatedAt &&
      contactData?.SelfAttestationUpdatedAt !== null &&
      contactData?.SelfAttestationUpdatedAt !== '';

    return !hasAttested; // Show popup if they haven't attested
  };

  // Store the current promise resolver for professional status popup
  const [professionalStatusResolver, setProfessionalStatusResolver] = React.useState<((value: { shouldContinue: boolean; isNonPhysician?: boolean }) => void) | null>(null);

  // Show professional status popup and handle the result
  const showProfessionalStatusPopup = (): Promise<{ shouldContinue: boolean; isNonPhysician?: boolean }> => {
    return new Promise((resolve) => {
      // Store the resolver so we can call it from the onSubmit handler
      setProfessionalStatusResolver(() => resolve);

      // Click the professional status modal to open it - search by text content
      const buttons = document.querySelectorAll('button');
      let professionalStatusButton: HTMLElement | null = null;

      for (let i = 0; i < buttons.length; i++) {
        if (buttons[i].textContent?.includes('Update my certificate type')) {
          professionalStatusButton = buttons[i];
          break;
        }
      }

      if (professionalStatusButton) {
        professionalStatusButton.click();
      } else {
        resolve({ shouldContinue: true }); // If button not found, proceed
      }
    });
  };

  const [licenses, setLicenses] = useState<MedicalLicense[]>([]);
  const [parsModalOpen, setParsModalOpen] = useState(false);
  const [parsResolver, setParsResolver] = useState<((result: 'accept' | 'decline' | 'close') => void) | null>(null);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [deadlineWarningOpen, setDeadlineWarningOpen] = useState(false);
  const [approachingDeadlineItems, setApproachingDeadlineItems] = useState<any[]>([]);
  const [missingProfileFields, setMissingProfileFields] = useState<string[]>([]);
  const deadlineWarningCheckedRef = useRef(false);
  const activityWarningContinueRef = useRef<(() => void) | null>(null);

  const showPARSModal = (): Promise<'accept' | 'decline' | 'close'> => {
    return new Promise((resolve) => {
      setParsResolver(() => resolve);
      setParsModalOpen(true);
    });
  };

  const checkLearnerEligibility = async (): Promise<string[]> => {
    const acepid = userData.acepMemberStatus === 2 ? contactData?.acepid : userData.acepid;
    if (!acepid) return [];
    try {
      const response = await axios.get(`${API_URL}/cmecontacts/validatelearnereligibility`, {
        params: { acepid: acepid.toLowerCase() }
      });
      const { missingFields = [] } = response.data as { missingFields: string[]; licenseValid: boolean; isEligible: boolean };
      const fieldLabels: Record<string, string> = {
        FirstName: 'First Name',
        LastName: 'Last Name',
        NPI_Number: 'NPI Number',
        Birthdate: 'Birth Date',
        City: 'City',
        State: 'State',
        Country: 'Country',
        License_Number: 'State License Number',
        'State of Licensure': 'State of Licensure',
      };
      return missingFields.map((f: string) => fieldLabels[f] || f);
    } catch {
      return [];
    }
  };

  const checkActivityEligibility = async (): Promise<{ canClaim: boolean; canSubmitToACCME: boolean; reasons: string[] }> => {
    const typeUpper = (currentActivityTypeName || '').toUpperCase();
    const isPARSEligibleType = typeUpper.includes('ENDURING') || typeUpper.includes('LIVE');

    // Only Live and Enduring activities submit to PARS — skip validation for all other types
    if (!currentCMEActivityId || !isPARSEligibleType) {
      return { canClaim: true, canSubmitToACCME: false, reasons: [] };
    }
    try {
      const response = await axios.get(`${API_URL}/cmeactivity/validateeligibility`, {
        params: { activityId: currentCMEActivityId }
      });
      const { canClaim = true, canSubmitToACCME = false, reasons = [] } =
        response.data as { externalIdValid: boolean; canClaim: boolean; canSubmitToACCME: boolean; reasons: string[] };
      return { canClaim, canSubmitToACCME, reasons };
    } catch {
      return { canClaim: true, canSubmitToACCME: true, reasons: [] };
    }
  };

  const handlePARSAccept = () => {
    if (parsResolver) { parsResolver('accept'); setParsResolver(null); }
    setParsModalOpen(false);
  };

  const handlePARSDecline = () => {
    if (parsResolver) { parsResolver('decline'); setParsResolver(null); }
    setParsModalOpen(false);
  };

  const handlePARSModalClose = () => {
    if (parsResolver) { parsResolver('close'); setParsResolver(null); }
    setParsModalOpen(false);
  };

  const getCMETrackingUnclaimedRecords = () => {
    if (
      contactData?.contactid !== "" &&
      trackingAPIData &&
      !trackingAPICalled &&
      topicAPIData &&
      !topicAPICalled &&
      activityTypeAPIData &&
      !activityTypeAPICalled
    ) {
      var rows = trackingAPIData || [];
      if (rows.length <= 0) setEnableTranscript("#DDDDDD");

      setCMETrackingDetails(rows);
      setCpyCMETrackingDetails(rows);
      setSearchListData(rows);
      setShowData(true);

      setLoadNavHeight(true);

      if (totalAPICalls === 0) {
        setCurrent("");
        setFormDirty(false);
        //To hide the wait indicator
        showSpinner(false);
      }

      if (promiseValue.promiseObject.length !== 2) {
        promiseValue.setPromiseObject((prev: any) => [
          ...prev,
          "cmetrackingunclaimed",
        ]);
        promiseValue.setPromiseObject((prev: any) => [
          ...prev,
          "cmetrackingclaimed",
        ]);
      }
    }
  };

  const getCMETopicList = () => {
    if (trackingAPIData && topicAPIData && !topicAPICalled) {
      let listcmetopic: any[] = topicAPIData.filter(
        (item: any) => item.Id !== -1
      );
      if (!listcmetopic.some((item) => item.Id === -1)) {
        listcmetopic.unshift({ Id: -1, Name: "" });
      }
      setCmeTopicList(listcmetopic);
    }
  };

  const getActivityTypeList = () => {
    if (trackingAPIData && activityTypeAPIData && !activityTypeAPICalled) {
      let listcmeactivitytypes: any[] = activityTypeAPIData.filter(
        (item) => item !== ""
      );


      setcmeActivityTypeList(listcmeactivitytypes);
    }
  };

  useEffect(() => {
    if (!props_Input || !cmeTrackingDetails.length || !contactData?.contactid || isContactLoading) return;
    if (deadlineWarningCheckedRef.current) return; // already processed for this mount

    // Module-level check: synchronous, survives remounts, keyed per user.
    // This is the primary guard against showing twice on quick navigation.
    const sessionShownAt = deadlineWarningShownThisSession.get(contactData.contactid);
    if (sessionShownAt && Date.now() - sessionShownAt < 24 * 60 * 60 * 1000) {
      deadlineWarningCheckedRef.current = true;
      return;
    }

    // DB-backed check: guards across browser sessions / devices.
    const lastShown = contactData?.DeadlineWarningLastShown;
    if (lastShown) {
      const elapsed = Date.now() - new Date(lastShown).getTime();
      if (elapsed < 24 * 60 * 60 * 1000) {
        deadlineWarningCheckedRef.current = true;
        return;
      }
    }

    const approaching = cmeTrackingDetails.filter((item: any) =>
      !isLiveActivity(item.ActivityTypeName) &&
      !isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate) &&
      showDeadlineDateRed(item.ActivityTypeName, item.FormatActivityEndDate)
    );

    deadlineWarningCheckedRef.current = true; // mark done regardless of whether popup shows
    if (approaching.length > 0) {
      const sorted = [...approaching].sort((a: any, b: any) => {
        const dateA = a.ActivityEndDate ? new Date(a.ActivityEndDate).getTime() : 0;
        const dateB = b.ActivityEndDate ? new Date(b.ActivityEndDate).getTime() : 0;
        return dateA - dateB;
      });
      setApproachingDeadlineItems(sorted);
      setDeadlineWarningOpen(true);
      // Set module-level guard synchronously — this is immediately visible on remount
      // even before React commits the context state update below.
      deadlineWarningShownThisSession.set(contactData.contactid, Date.now());
      // Update context optimistically so the DB check also passes on remount.
      updateDeadlineWarningLastShown(new Date().toISOString());
      // Persist to DB for cross-session / cross-device protection.
      axios.patch(`${API_URL}/cmecontacts/${contactData.contactid}/deadlinewarninglastshown`)
        .then((res: any) => updateDeadlineWarningLastShown(res.data.DeadlineWarningLastShown))
        .catch((err: any) => console.error('Failed to update DeadlineWarningLastShown:', err?.message));
    }
  }, [cmeTrackingDetails, contactData?.DeadlineWarningLastShown, contactData?.contactid, isContactLoading]);

  function redirectEducation() {
    window.open(OpportunitiesLink, "_blank");
  }

  const dvShowHideAccordianDetails = (event: any, item: IClaimdDetails, listIndex: number) => {
    {
      let updatedData: any;

      let proceedClick = false;
      for (const [index, element] of event.target.classList.entries()) {
        if (
          element === "unclaim-claimRow-delete" ||
          element === "unclaim-dateRow" ||
          element === "unclaim-eventRow" ||
          element === "unclaim-deadlineRow" ||
          element === "unclaim-maxHoursRow" ||
          element === "transcript-maxHoursRow" ||
          element === "unclaim-claimRow" ||
          (element === "MuiSvgIcon-root" &&
            event.target.attributes &&
            event.target.attributes["data-testid"].value !==
            "DeleteOutlineIcon" &&
            event.target.attributes["data-testid"].value !==
            "FileUploadOutlinedIcon" &&
            event.target.attributes["data-testid"].value !== "CloseIcon" &&
            event.target.attributes["data-testid"].value !== "CalendarIcon" &&
            event.target.attributes["data-testid"].value !==
            "ArrowDropDownIcon" &&
            event.target.attributes["data-testid"].value !== "ArrowRightIcon" &&
            event.target.attributes["data-testid"].value !== "ArrowLeftIcon")
        ) {
          proceedClick = true;
          break;
        }
      }

      if (proceedClick) {
        if (current !== item.Id) {
          //for each time, clear the CertificateUrl variable
          //this variable will set value on click of file upload control
          //Based on this value, will decide to call postFile function to upload file or not on SAVE button click
          setUploadedCertificateUrl("");
          //end
          setInvalidFileMessage(false);
          setCurrent(item.Id);
          setFormDirty(false);
          claimCMEHours = props_Input
            ? "0"
            : item.RemainingHoursToClaim.toString(); //ToDo
          setclaimAddTopicHours(0);
          item.IsExpand = true;
        } else {
          item.IsExpand = false;
          setCurrent("");
        }

        //YT   set current value for edit
        setCurrentActivity(item.Name);
        //Yt set current value for completion Date
        setCurrentDate(
          convertToMaterialUIDateFormat(item.FormatCompletionDate)
        );
        // Yt set current value for activity type
        setCurrentActivityType(item.CME_ActivityType_Id);

        updatedData = cmeTrackingDetails.map((obj) => {
          if (item.Id == obj.Id && item.IsExpand) {
            return { ...obj, IsExpand: true };
          } else {
            return { ...obj, IsExpand: false };
          }
        });

        setCMETrackingDetails(updatedData);

        if (item.ApprovedByACEP) setApprovedByAcep(true);
        else setApprovedByAcep(false);

        if (item.ApprovedByAMA) setApprovedByAMA(true);
        else setApprovedByAMA(false);

        if (props_Input) {
          //fill empty topic record each time when expanded/selected activity record Unclaimed CME dashboard
          if (item.ApprovedByAMA) {
            setTopicInfo([
              {
                NewUID: uuid(),
                TopicId: 23,
                TopicHours: claimCMEHours,
                IsValidTopicName: true,
                IsValidTopicHours: true,
                IsValidAMAPRATopic: true,
                RecordID: "-1",
                IsUpdated: true,
              }
              //To DO : Once finalized the credit types variables from CME Accrediation
              //Then will use the below topics as default like ApprovedByAMA, ApprovedByACEP similar  to AOA and APA
              // ,{
              //   NewUID: uuid(),
              //   TopicId: 24,
              //   TopicHours: claimCMEHours,
              //   IsValidTopicName: true,
              //   IsValidTopicHours: true,
              //   IsValidAMAPRATopic: true,
              //   RecordID: "-1",
              //   IsUpdated: true,
              // },
              // {
              //   NewUID: uuid(),
              //   TopicId: 36,
              //   TopicHours: claimCMEHours,
              //   IsValidTopicName: true,
              //   IsValidTopicHours: true,
              //   IsValidAMAPRATopic: true,
              //   RecordID: "-1",
              //   IsUpdated: true,
              // },
            ]);
            setInnerHeightAddTopicDiv(innerHeight);
          } else {
            setTopicInfo([]);
            setInnerHeightAddTopicDiv(innerHeight);
          }
        } else {
          //reset the delete record id when expanded the activity
          setDeleteTranscriptRecords("");

          //fill the topic infor for selected/expanded activity record on Most Recent Activites dashboard
          //loop for all saved Topic records
          setTopicInfo(
            item.CME_Tracking_Details.map((ele: any) => ({
              NewUID: ele.Id,
              TopicId: ele.CME_Topic_Id,
              TopicHours: ele.Hours,
              IsValidTopicName: true,
              IsValidTopicHours: true,
              IsValidAMAPRATopic: cmeTopicList.find(item => item.Id === ele.CME_Topic_Id)?.isCreditType,
              RecordID: item.Id,
              IsUpdated: false,
            }))
          );

          var calculateHeight =
            100 *
            (item.CME_Tracking_Details.filter(
              (ele: { CME_Topic_Id: number }) => ele.CME_Topic_Id !== None_Topic_Id
            ).length -
              2);

          const innerHeightDiv =
            (item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id ? selfReportedInnerHeight : addedTopicInnerHeight) +
            (calculateHeight > 0 ? calculateHeight : 0);

          setInnerHeightAddTopicDiv(
            item.CME_Tracking_Details.length > 0
              ? innerHeightDiv < innerHeight
                ? innerHeight
                : innerHeightDiv
              : item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id
                ? selfReportedInnerHeight
                : innerHeight
          );
        }

        event.preventDefault();
        setClaimCMETrackingId(item.Id);
        setCurrentCMEActivityId(item.CME_Activity_Id ?? null);
        setCurrentActivityTypeName(item.ActivityTypeName ?? '');
        setCurrentActivityEndDate(item.FormatActivityEndDate ?? null);
        setCurrentTrackingStatusId(Number(item.CME_Tracking_Status_Id ?? 0));
        setClaimedExistingCMEHours(Number(item.ClaimedHours));
        setRemainingHoursToClaim(
          props_Input
            ? Number(item.RemainingHoursToClaim)
            : Number(item.MaxHours)
        );
        setListIndex(listIndex);
      }
    }
    //this will adjust the heigh on dashboard

    setLoadNavHeight(true);
  };

  const GetSetTopicInfo = (Id: Number, Hours: string) => {
    setTopicInfo((prevTopic) => [
      ...prevTopic,
      {
        NewUID: uuid(),
        TopicId: Id,
        TopicHours: Hours,
        IsValidTopicName: true,
        IsValidTopicHours: true,
        IsValidAMAPRATopic: false,
        RecordID: "-1",
        IsUpdated: false,
      },
    ]);
  };

  const onAddTopicInfo = (event: any, item: any) => {
    event.preventDefault();
    GetSetTopicInfo(-1, "0");
    setDisableAddTranscriptButton(true);

    const innerHeightDiv =
      (item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id ? selfReportedInnerHeight : addedTopicInnerHeight) +
      100 *
      (item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id
        ? topicInfo.filter((data) => data.TopicId !== None_Topic_Id).length - 1
        : approvedByAcep
          ? topicInfo.filter((data) => data.TopicId !== None_Topic_Id).length - 1
          : topicInfo.filter((data) => data.TopicId !== None_Topic_Id).length - 1);

    setInnerHeightAddTopicDiv(
      topicInfo.length > 0
        ? innerHeightDiv < innerHeight
          ? innerHeight
          : innerHeightDiv
        : item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id
          ? selfReportedInnerHeight
          : innerHeight
    );
  };

  const roundUpClaimedHours = (event: any, Host: string) => {
    let roundUpValue = GetRoundUpValue(event);

    let newTopicInfo = topicInfo.map((el) =>
      parseFloat(el.TopicHours) > parseFloat(roundUpValue)
        ? {
          ...el,
          IsValidTopicHours:
            el.TopicId === None_Topic_Id,
          TopicHours:
            el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType && Host !== "ABEM"
              ? roundUpValue
              : el.TopicHours,
          IsUpdated: el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType
        }
        : {
          ...el,
          IsValidTopicHours: true,
          TopicHours:
            el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType && Host !== "ABEM"
              ? roundUpValue
              : el.TopicHours,
          IsUpdated: el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType,
        }
    );
    setTopicInfo(newTopicInfo);
    claimCMEHours = roundUpValue;
  };

  const roundUpTopicHours = (
    event: any,
    iIndex: number,
    key: "TopicId" | "TopicHours"
  ) => {
    let roundUpValue = GetRoundUpValue(event);

    let selectedVal = roundUpValue;
    const topicByIndex = topicInfo[iIndex];

    validateTopicInfoDetails(selectedVal, iIndex, topicByIndex, key, true);
  };

  const onChangeCMEHoursText = (event: any, Host: string) => {
    event.preventDefault();
    setShowLeftHandTopicHoursValid(true);
    setFormDirty(true);

    const iClaimCMEHours = event.target.value.trim();

    if (!isNaN(iClaimCMEHours)) {
      let newTopicInfo = topicInfo.map((el) =>
        parseFloat(el.TopicHours) > parseFloat(iClaimCMEHours)
          ? {
            ...el,
            IsValidTopicHours:
              el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType,
            TopicHours:
              el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType && Host !== "ABEM"
                ? iClaimCMEHours
                : el.TopicHours,
            IsUpdated: el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType,
          }
          : {
            ...el,
            IsValidTopicHours: true,
            TopicHours:
              el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType && Host !== "ABEM"
                ? iClaimCMEHours
                : el.TopicHours,
            IsUpdated: el.TopicId === None_Topic_Id || cmeTopicList.find(item => item.Id === el.TopicId)?.isCreditType,
          }
      );

      setTopicInfo(newTopicInfo);
      claimCMEHours = iClaimCMEHours;

      // If self-reported activity, set remaining hours to claimed hours
      if (currentTrackingStatusId === SelfReported_CME_Tracking_Status_Id) {
        setRemainingHoursToClaim(Number(iClaimCMEHours));
      }

      setAddTrnascriptButtonState();
    }
  };

  const selectedTopicIdExists = (Id: number, Index: number): boolean => {
    return topicInfo
      .filter((el, i) => i !== Index)
      .some((el) => el.TopicId === Id && el.IsValidTopicName === true);
  };

  //This function will call when Added Topic Details gets changed by User. It could be Hours or Topic Name
  const onChangeAddedTopicDetails = (
    event: any,
    iIndex: number,
    key: "TopicId" | "TopicHours"
  ) => {
    let selectedVal = event.target.value.trim();
    const topicByIndex = topicInfo[iIndex];

    //If Topic Hours are not a number then ignore the further process
    if ((key === "TopicHours" && !isNaN(selectedVal)) || key === "TopicId") {
      validateTopicInfoDetails(selectedVal, iIndex, topicByIndex, key, true);
      setFormDirty(true);
    }
  };

  const validateTopicInfoDetails = (
    selectedVal: string,
    iIndex: number,
    topicByIndex: iTopicInfo,
    key: "TopicId" | "TopicHours",
    IsUpdated?: false | true
  ) => {
    if (key === "TopicHours") {
      const iAddTopicHours = selectedVal;

      if (
        parseFloat(iAddTopicHours) > parseFloat(claimCMEHours) ||
        parseFloat(iAddTopicHours) <= 0
      ) {
        topicByIndex["IsValidTopicHours"] = false;
      } else {
        topicByIndex["IsValidTopicHours"] = true;
      }
      topicByIndex[key] = selectedVal;
    }

    if (key === "TopicId") {
      if (
        selectedTopicIdExists(Number(selectedVal), iIndex) ||
        selectedVal == "-1"
      ) {
        topicByIndex["IsValidTopicName"] = false;
      } else {
        topicByIndex["IsValidTopicName"] = true;
      }

      topicByIndex[key] = Number(selectedVal);
    }

    //This will update the changed value in the topicinfo array
    if (topicByIndex.RecordID === "-1" || IsUpdated)
      topicByIndex["IsUpdated"] = true;

    setTopicInfo([
      ...topicInfo.slice(0, iIndex),
      topicByIndex,
      ...topicInfo.slice(iIndex + 1, topicInfo.length),
    ]);

    setAddTrnascriptButtonState();
  };

  const onSubmit =
    (
      NewUID: string,
      iIndex: Number,
      RecordID: string,
      selectedItemStatusID: number,
      listRowIndex: number, //this is for list row index and set the cursor to current row
    ) =>
      (event: any) => {
        event.preventDefault();

        setTopicInfo((prevAddedTopicInfo) => {
          return prevAddedTopicInfo.filter((value, i) => value.NewUID !== NewUID);
        });

        setAddTrnascriptButtonState();
        setInnerHeightAddTopicDiv((innerHeight) =>
          innerHeight - 100 < (selectedItemStatusID === SelfReported_CME_Tracking_Status_Id ? selfReportedInnerHeight : innerHeight)
            ? selectedItemStatusID === SelfReported_CME_Tracking_Status_Id
              ? selfReportedInnerHeight
              : innerHeight
            : innerHeight - 100
        );

        //in case of Transcript, add deleted id in the array to actulal delete records on save button click
        if (!props_Input && RecordID !== "-1") {
          //To show the wait indicator
          showSpinner(true);

          apiProfiles.url = "/cmetrackingdetail";
          apiProfiles.remove(NewUID).then((data: any) => {
            removeQueries(["claimedCMEFilterData", "claimedCMEData"]);
            event.target[0].click();
            msg = "Transcript Activity Processed Successfully!";
            setOpenAlertMsg(true);
          });
          setSelectedRowIndex(listRowIndex);
        } else {
          //To delete the records who has not submitted yet
          //To hide the wait indicator if api call not made
          showSpinner(false);
        }
        setSelectedOption([{ label: "" }]);
        setToShowSelectFiltersDiv(false);
      };

  const setAddTrnascriptButtonState = (): boolean => {
    if (
      topicInfo.some(
        (details: iTopicInfo) =>
          parseFloat(claimCMEHours) < parseFloat(details.TopicHours) ||
          details.TopicId == -1 ||
          details.TopicHours == "" ||
          Number(details.TopicHours) == 0 ||
          claimCMEHours == "0" ||
          parseFloat(claimCMEHours) > remainingHoursToClaim ||
          !details.IsValidTopicHours ||
          !details.IsValidTopicName ||
          dayjs(currentDate).utc() > dayjs(new Date()).utc()
      )
    ) {
      setDisableAddTranscriptButton(true);
      return true;
    } else {
      setDisableAddTranscriptButton(false);
      return false;
    }
  };

  let totalAPICalls = 0;

  const onUnclaimActivityClick = async (
    event: any,
    cme_tracking_Id: string,
    cme_tracking_statusId: number,
    listRowIndex: number, //this is for list row index and set the cursor to current row
    item?: any, //transcript row being unclaimed, used to check prior PARS/ACCME submission
  ) => {

    showSpinner(true);
    event.preventDefault();
    event &&
      event.currentTarget &&
      event.currentTarget
        .getElementsByClassName("model-cancel-button")[0]
        .click();
    totalAPICalls = 1;
    let method = "POST";
    let requestOptions = {
      cme_tracking_Id: cme_tracking_Id,
      cme_tracking_statusId: cme_tracking_statusId,
    };
    await executeAPI(requestOptions, "/cmetracking/unclaimactivity", method);

    // Unclaim has completed — if this activity was previously accepted by ACCME, notify PARS to
    // remove the record. CE Broker has no delete concept, so only the ACCME flag gates this.
    // Skipped entirely when PARS is switched off for this environment.
    if (FEATURE_ACCREDITATION_ENABLED && isAccreditationSiteEnabled('PARS') && item && item.IsACCMEAccreditationAccepted && contactData?.contactid) {
      axios.post(`${API_URL}/pars/learner/save`, {
        cmeTrackingId: cme_tracking_Id,
        contactId: contactData.contactid,
        recordAction: 'delete',
      }).catch((err: any) => {
        console.error('Error calling PARS saveLearnerActivity (delete), method- onUnclaimActivityClick:', err);
      });
    }

    setSelectedRowIndex(listRowIndex);
    setSelectedOption([{ label: "" }]);
    setToShowSelectFiltersDiv(false);
  };

  const onAddTranscriptDetails = async (event: any, item?: any) => {
    errorMsg = "";
    let effectiveConsentAccepted: boolean | null | undefined = contactData?.PARSConsentAccepted;

    // State licensing board (PARS/CE Broker) attestation — Claim Dashboard only (not Transcript tab).
    // Both sites share the one FEATURE_ACCREDITATION_ENABLED flag — CE Broker has no separate toggle.
    if (FEATURE_ACCREDITATION_ENABLED && props_Input && !isNonPhysician && isMDorDO) {
      if (effectiveConsentAccepted === null || effectiveConsentAccepted === undefined) {
        const result = await showPARSModal();
        if (result === 'close') return;
        const accepted = result === 'accept';
        effectiveConsentAccepted = accepted;
        if (accepted) {
          // Save consent in background — eligibility check runs after spinner is on
          axios.patch(`${API_URL}/cmecontacts/${contactData?.contactid}/parsconsent`, { PARSConsentAccepted: true })
            .then(() => updatePARSConsent(true))
            .catch((err) => console.error('Error saving PARS consent:', err));
        } else {
          try {
            await axios.patch(`${API_URL}/cmecontacts/${contactData?.contactid}/parsconsent`, { PARSConsentAccepted: false });
            updatePARSConsent(false);
          } catch (err) {
            console.error('Error saving PARS consent:', err);
          }
        }
      }
    }

    // Spinner ON — persists through eligibility checks and entire save flow
    showSpinner(true);
    let isAPICalled = false;
    totalAPICalls = 0;

    //on Claim CME Dashboard, if there is no topic in case of if activity is not approved by AMA
    //in this case no default AMA PRA credit type will appear so user should add at least one topic
    //to proceed
    if (props_Input && topicInfo.length === 0) {
      GetSetTopicInfo(-1, "0");
      setDisableAddTranscriptButton(true);
      showSpinner(false);
      return;
    }

    // Only proceed if there is Claimed Hours is not 0
    if (claimCMEHours === "0" || Number(claimCMEHours) === 0) {
      setShowLeftHandTopicHoursValid(true);
      showSpinner(false);
      return;
    }

    if (setAddTrnascriptButtonState()) {
      //To hide the wait indicator
      showSpinner(false);

      topicInfo.map((element, index) => {
        setShowLeftHandTopicHoursValid(true);

        if (
          !(
            element.TopicId === 23 &&
            approvedByAMA &&
            element.IsValidAMAPRATopic
          )
        ) {
          validateTopicInfoDetails(
            element.TopicId.toString(),
            index,
            topicInfo[index],
            "TopicId",
            false
          );
          validateTopicInfoDetails(
            element.TopicHours.toString(),
            index,
            topicInfo[index],
            "TopicHours",
            false
          );
        }
      });
    } else {
      // Board submission for this claim, built below once eligibility passes but only sent after
      // the claim itself succeeds — a claim the backend rejects (409: already claimed from another
      // tab/browser) must not reach PARS/CE Broker, and the submission needs the topic rows the
      // claim inserts.
      let submitClaimToBoards: (() => void) | undefined;

      // Consolidated state licensing board eligibility — Claim Dashboard only
      // Gates: FEATURE_ACCREDITATION_ENABLED ON (covers both PARS and CE Broker — no separate flag), consent Yes,
      //        physician MD/DO, activity AMA-approved, activity is Live or non-expired Enduring.
      //        Site routing (PARS vs CE Broker) is resolved server-side from here on — no state-specific
      //        check belongs in this gate.
      if (FEATURE_ACCREDITATION_ENABLED && props_Input && !isNonPhysician && isMDorDO && effectiveConsentAccepted === true && approvedByAMA) {
        const typeUpper = (currentActivityTypeName || '').toUpperCase();
        const isLiveType = typeUpper.includes('LIVE');
        const isEnduringType = typeUpper.includes('ENDURING');
        const isPARSEligibleType = isLiveType || (isEnduringType && !isActivityExpired(currentActivityTypeName, currentActivityEndDate));

        if (isPARSEligibleType) {
          const [learnerMissing, activityResult] = await Promise.all([
            checkLearnerEligibility(),
            checkActivityEligibility()
          ]);

          const allMissing = [...learnerMissing, ...activityResult.reasons];

          if (allMissing.length > 0) {
            setMissingProfileFields(allMissing);
            showSpinner(false);

            // Always warning only — claim is never blocked, user closes modal and claim proceeds
            await new Promise<void>((resolve) => {
              activityWarningContinueRef.current = resolve;
              setProfileModalOpen(true);
            });
            showSpinner(true);
          }
          else{
                if (props_Input && !isNonPhysician && contactData?.PARSConsentAccepted === true && FEATURE_ACCREDITATION_ENABLED) {
                  submitClaimToBoards = () => axios.post(`${API_URL}/pars/learner/save`, {
                    cmeTrackingId: claimCMETrackingId,
                    contactId: contactData.contactid,
                    recordAction: recordAction,
                  }).then((response: any) => {
                    const results: any[] = response?.data?.results ?? response?.data?.Results ?? [];
                    const siteAlerts = buildSiteAccreditationAlerts(results);
                    const parsResult = siteAlerts['PARS'];
                    if (parsResult) {
                      setParsAlertMsg(parsResult.message);
                      setParsAlertSeverity(parsResult.severity);
                      setParsAlertOpen(true);
                      pushAccreditationToast('pars');
                    }
                    const ceBrokerResult = siteAlerts['CEBROKER'];
                    if (ceBrokerResult) {
                      setCeBrokerAlertMsg(ceBrokerResult.message);
                      setCeBrokerAlertSeverity(ceBrokerResult.severity);
                      setCeBrokerAlertOpen(true);
                      pushAccreditationToast('cebroker');
                    }
                  }).catch((err: any) => {
                    // Request itself failed (e.g. network error) before any per-site results came
                    // back — there's no site breakdown to key off of, so show both banners as
                    // failed rather than guessing which site(s) would have applied. Same
                    // claimRejected template as a real per-site rejection — no separate message.
                    // Each banner is still gated on its site being live in this environment, so a
                    // site hidden from the UI stays silent on failures too.
                    console.error('Error calling accreditation saveLearnerActivity, method- executeAPI:', err);
                    if (isAccreditationSiteEnabled('PARS')) {
                      setParsAlertMsg(ACCREDITATION_MESSAGES.claimRejected(ACCREDITATION_SITES.PARS.label));
                      setParsAlertSeverity('error');
                      setParsAlertOpen(true);
                      pushAccreditationToast('pars');
                    }
                    if (isAccreditationSiteEnabled('CEBROKER')) {
                      setCeBrokerAlertMsg(ACCREDITATION_MESSAGES.claimRejected(ACCREDITATION_SITES.CEBROKER.label));
                      setCeBrokerAlertSeverity('error');
                      setCeBrokerAlertOpen(true);
                      pushAccreditationToast('cebroker');
                    }
                  });
              }
          }
        }
      }

      setShowLeftHandTopicHoursValid(false);
      //This will check user session is active or not
      localStorage.setItem("loadSSOData", "1");
      event.preventDefault(event);
      let requestOptions: any = {};
      let mainRecordUpdatePromise: Promise<any> | undefined;

      let savedActivityName; // YT
      let savedActivityType; //YT

      if (!props_Input) {
        //To check that CME Tracking Hours updated or not
        if (
          Number(claimCMEHours) !== claimedExistingCMEHours ||
          UploadedCertificateUrl.length > 0 ||
          (currentActivity && currentActivity?.length > 0) ||
          (currentActivitytype && currentActivitytype?.length > 0) ||
          (currentDate && currentDate.length > 0)
        ) {
          isAPICalled = true;
          totalAPICalls += 1;
          let method = "PUT";

          if (UploadedCertificateUrl.length > 0) {
            const blobName = await postFile();

            //if file not uploaded then show the error message
            //and don not include that certificateURL in the request
            if (blobName.length > 0) {

              errorMsg = "";
              msg = "";
              setOpenAlertMsg(false);

              requestOptions = {
                Id: claimCMETrackingId,
                ClaimedHours: Number(claimCMEHours),
                ...(currentTrackingStatusId === SelfReported_CME_Tracking_Status_Id && { MaxHours: Number(claimCMEHours) }),
                Name: currentActivity, //YT
                Certificate_url: blobName,
                CompletionDate: currentDate, //YT
                CME_ActivityType_Id: currentActivitytype, //YT
              };

            } else {
              errorMsg = "File not saved. Please try again to uplaod the file.";
              msg = "File not saved. Please try again to uplaod the file.";
              setOpenAlertMsg(true);


              requestOptions = {
                Id: claimCMETrackingId,
                ClaimedHours: Number(claimCMEHours),
                ...(currentTrackingStatusId === SelfReported_CME_Tracking_Status_Id && { MaxHours: Number(claimCMEHours) }),
                Name: currentActivity, //YT
                CompletionDate: currentDate, //YT
                CME_ActivityType_Id: currentActivitytype, //YT
              };
            }

          } else {
            requestOptions = {
              Id: claimCMETrackingId,
              ClaimedHours: Number(claimCMEHours),
              ...(currentTrackingStatusId === SelfReported_CME_Tracking_Status_Id && { MaxHours: Number(claimCMEHours) }),
              Name: currentActivity, //YT
              CompletionDate: currentDate, //YT
              CME_ActivityType_Id: currentActivitytype, //YT
            };
          }

          mainRecordUpdatePromise = executeAPI(
            requestOptions,
            "/cmetracking/" + claimCMETrackingId,
            method
          );
        }

        //To Add the Transcript Topic Details
        const topicDetailPromises: Promise<any>[] = [];

        if (
          topicInfo &&
          topicInfo.length > 0 &&
          topicInfo.filter((res) => res.RecordID == "-1").length > 0
        ) {
          isAPICalled = true;
          totalAPICalls += 1;
          let method = "POST";
          requestOptions = {
            CME_Tracking_Id: claimCMETrackingId,
            CME_Claim_Hours: 0,
            CME_Tracking_Status: 0,
            CME_Existing_Claimed_Hours: claimedExistingCMEHours,
            CME_topic_info: topicInfo
              .filter((res) => res.RecordID == "-1" && res.TopicHours !== "0")
              .map(
                ({ IsValidTopicHours, IsValidTopicName, RecordID, ...item }) =>
                  item
              ),
          };
          const addTopicDetailPromise = executeAPI(requestOptions, "/cmetrackingdetail", method);
          if (addTopicDetailPromise) topicDetailPromises.push(addTopicDetailPromise);
        }

        //To Update the Transcript Topic Details
        if (
          topicInfo &&
          topicInfo.length > 0 &&
          topicInfo.filter((res) => res.RecordID !== "-1" && res.IsUpdated)
            .length > 0
        ) {
          isAPICalled = true;
          totalAPICalls += 1;
          let method = "PUT";
          requestOptions = {
            CME_Tracking_Details: topicInfo
              .filter((res) => res.RecordID !== "-1" && res.IsUpdated)
              .map(
                ({ IsValidTopicHours, IsValidTopicName, RecordID, ...item }) =>
                  item
              ),
          };

          const updateTopicDetailPromise = executeAPI(requestOptions, "/cmetrackingdetail", method);
          if (updateTopicDetailPromise) topicDetailPromises.push(updateTopicDetailPromise);
        }

        // Resubmit to the state licensing boards (PARS/CE Broker) on a Transcript hours edit.
        // Only when: this activity was accepted by at least one board already (either flag true —
        // site routing for the actual resubmission is still resolved server-side, this just gates
        // whether to call the endpoint at all), and the new hours are greater than what was
        // previously claimed — claimedExistingCMEHours was captured before this edit, so the
        // difference below reflects only the incremental hours, not the resubmission of hours
        // already reported.
        // recordAction 'add' + hours: we compute the incremental hours here (newHours -
        // previousHours) and send that exact number — the backend reports it as-is to
        // ACCME/CE Broker with no recalculation of its own.
        // Waits on mainRecordUpdatePromise (the /cmetracking hours PUT above) and topicDetailPromises:
        // PARS reads CME_Tracking_Details.Hours, which those calls just wrote, and this must only
        // fire once the hours update itself has actually succeeded — not merely been attempted.
        const hoursDiffSincePriorClaim = Number(claimCMEHours) - Number(claimedExistingCMEHours);
        if (
          FEATURE_ACCREDITATION_ENABLED &&
          item &&
          // Only resubmit for sites still live in this environment — a row accepted solely by a
          // switched-off site must not trigger a resubmission.
          getAcceptedSiteKeys(item).length > 0 &&
          hoursDiffSincePriorClaim > 0 &&
          contactData?.contactid
        ) {
          Promise.all([mainRecordUpdatePromise, ...topicDetailPromises]).then((results) => {
            // A save the backend refused (409, e.g. a topic another tab already added) resolves
            // false — don't report hours from a save that didn't fully go through.
            if (results.some((saved) => saved === false)) return;
            axios.post(`${API_URL}/pars/learner/save`, {
              cmeTrackingId: claimCMETrackingId,
              contactId: contactData.contactid,
              recordAction: 'add',
              hours: hoursDiffSincePriorClaim,
            }).catch((err: any) => {
              console.error('Error calling PARS saveLearnerActivity (transcript edit), method- onAddTranscriptDetails:', err);
            });
          }).catch((err: any) => {
            console.error('Error waiting for cmetracking hours update before PARS resubmission, method- onAddTranscriptDetails:', err);
          });
        }
      } else if (props_Input) {
        let newTopicInfo = topicInfo.slice();

        if (approvedByAcep) {
          let acepObject = {
            NewUID: uuid(),
            TopicId: 1,
            TopicHours: claimCMEHours,
            IsValidTopicName: true,
            IsValidTopicHours: true,
            IsValidAMAPRATopic: false,
            RecordID: "-1",
            IsUpdated: true,
          };
          newTopicInfo.push(acepObject);
        }

        isAPICalled = true;
        totalAPICalls += 1;
        let method = "POST";
        requestOptions = {
          CME_Tracking_Id: claimCMETrackingId,
          CME_Claim_Hours: claimCMEHours,
          //StatusEnum = {"Active": 1,"Confirmed":3, "Pending":4, "Manual":5,"Finalized" : 6};
          CME_Tracking_Status: 3,
          CME_Existing_Claimed_Hours: claimedExistingCMEHours,
          CME_topic_info: newTopicInfo
            .filter((res) => res.TopicHours !== "0")
            .map(({ IsValidTopicHours, IsValidTopicName, ...item }) => item),
        };

        executeAPI(requestOptions, "/cmetrackingdetail", method)?.then((claimed) => {
          if (claimed) submitClaimToBoards?.();
        });
      }


    }

    if (!isAPICalled) {
      //To hide the wait indicator if api call not made
      showSpinner(false);
    }
    setSelectedOption([{ label: "" }]);
    setToShowSelectFiltersDiv(false);
  };

  // apiProfiles swallows HTTP errors and resolves with the axios error. 409 = the backend refused a
  // duplicate: the activity was already claimed, or the topic is already recorded for it — from
  // another tab, browser or a replayed request. Say so and reload the lists so this tab stops
  // showing the stale state. Returns true when the response was such a conflict.
  const handleConflictResponse = (resp: any): boolean => {
    if (resp?.response?.status !== 409) return false;
    errorMsg = resp.response.data?.message || "This activity has already been claimed.";
    msg = errorMsg;
    setOpenAlertMsg(true);
    totalAPICalls -= 1;
    removeQueries([
      "unclaimedCMEFilterData",
      "unclaimedCMEData",
      "claimedCMEFilterData",
      "claimedCMEData",
    ]);
    return true;
  };

  const executeAPI = (requestOptions: any, apiPath: string, method: string) => {

    apiProfiles.url = apiPath;
    let apiPromise: Promise<any> | undefined;
    if (method === "PUT") {
      apiPromise = apiProfiles.put(requestOptions).then((resp: any) => {
        if (handleConflictResponse(resp)) return false;
        errorMsg = "";
        msg = "Transcript Activity Processed Successfully!";
        setOpenAlertMsg(true);

        totalAPICalls -= 1;

        if (totalAPICalls === 0)
          removeQueries(
            props_Input
              ? [
                "unclaimedCMEFilterData",
                "unclaimedCMEData",
                "claimedCMEFilterData",
                "claimedCMEData",
              ]
              : ["claimedCMEFilterData", "claimedCMEData"]
          );
        return true;
      });
    } else {
      if (method === "POST") {
        apiPromise = apiProfiles.post(requestOptions).then((resp: any) => {
          if (handleConflictResponse(resp)) return false;
          errorMsg = "";
          msg = "Transcript Activity Processed Successfully!";
          setOpenAlertMsg(true);

          totalAPICalls -= 1;

          if (totalAPICalls === 0) {
            removeQueries([
              "unclaimedCMEFilterData",
              "unclaimedCMEData",
              "claimedCMEFilterData",
              "claimedCMEData",
            ]);
          }
          return true;
        });
      }
    }
    setSelectedOption([{ label: "" }]);
    setToShowSelectFiltersDiv(false);
    return apiPromise;
  };

  function removeQueries(removeQuerriesList: string[] | string[][]) {
    removeQuerriesList.map((item) => {
      queryClient.removeQueries({ queryKey: [item] });
    });
    promiseValue.setPromiseObject([]);

    getCMETrackingUnclaimedRecords();
  }

  function removeQueriesForAdmin() {
    queryClient.removeQueries({ queryKey: ["unclaimedCMEFilterData"] });
    queryClient.removeQueries({ queryKey: ["claimedCMEFilterData"] });
    queryClient.removeQueries({ queryKey: ["claimedCMEData"] });
    queryClient.removeQueries({ queryKey: ["unclaimedCMEData"] });
    queryClient.removeQueries({ queryKey: ["generalRequirementData"] });
    queryClient.removeQueries({ queryKey: ["requirementData"] });
    queryClient.removeQueries({ queryKey: ["profileData"] });
    promiseValue.setPromiseObject([]);
  }

  const onchangeDateRange = (ev: any) => {
    ev.preventDefault();

    if (ev.target.value == "Date Range") setToShowSelectFiltersDateRange(true);
    else setToShowSelectFiltersDateRange(false);
  };

  const onSubmitFiltersOption = (ev: any) => {
    //Filter For date Input
    const dateInput =
      ev.currentTarget.getElementsByClassName("filters-date")[0].value; //ev.target[0].value;
    setfilterdateInput(dateInput);

    const dateRangeStartDate: string = ev.currentTarget
      .getElementsByClassName("filters-start-date")[0]
      .getElementsByTagName("input")[0].value; // moment(ev.target[1].value).format('MM/DD/YYYY')||'';
    setfilterdateRangeStartDate(dateRangeStartDate);

    const dateRangeEndDate: string = ev.currentTarget
      .getElementsByClassName("filters-end-date")[0]
      .getElementsByTagName("input")[0].value; //moment(ev.target[4].value).format('MM/DD/YYYY')||'';
    setfilterdateRangeEndDate(dateRangeEndDate);

    if (
      dateInput == "Date Range" &&
      (dateRangeStartDate === "Invalid date" ||
        dateRangeStartDate === "MM/DD/YYYY" ||
        dateRangeEndDate === "Invalid date" ||
        dateRangeEndDate === "MM/DD/YYYY")
    ) {
      ev.preventDefault(ev);

      if (
        dateRangeStartDate === "Invalid date" ||
        dateRangeStartDate === "MM/DD/YYYY"
      ) {
        ev.currentTarget.getElementsByClassName(
          "date-picker-modal"
        )[0].style.display = "block";
      }

      if (
        dateRangeEndDate === "Invalid date" ||
        dateRangeEndDate === "MM/DD/YYYY"
      ) {
        ev.currentTarget.getElementsByClassName(
          "end-date-picker-modal"
        )[0].style.display = "block";
      }
    } else {
      //For each time, apply the filters on actual list
      // setCpyCMETrackingDetails(cmeTrackingDetails)
      //here will handle to show the filtes div
      setToShowSelectFiltersDiv(true);

      //hide date range div
      setToShowSelectFiltersDateRange(false);

      ev.preventDefault(ev);

      //Filter for Activity Type
      const activityTypeInput = ev.currentTarget.getElementsByClassName(
        "filters-activity-type"
      )[0].value; //ev.target[7].value;
      setfilteractivityTypeInput(activityTypeInput);

      //Filter for Topic Type
      const topicInput =
        ev.currentTarget.getElementsByClassName("filters-topic")[0].value; //ev.target[8].value;
      setfiltertopicInput(topicInput);

      //Filter for accreditation source
      const accreditationSourceInput = ev.currentTarget.getElementsByClassName(
        "filters-accreditation-source"
      )[0].value; //ev.target[9].value;
      setfilteraccrediationsourceInput(accreditationSourceInput);

      filterAllActivities(
        dateInput,
        dateRangeStartDate,
        dateRangeEndDate,
        activityTypeInput,
        topicInput,
        accreditationSourceInput
      );
      //This will trigger the cancel click on the modal pop up and will close the pop up
      // ev.target[10].click();
      ev.currentTarget.getElementsByClassName("model-cancel-button")[0].click();
      setLoadNavHeight(true);
    }
  };

  //Apply All Filters based on user selection
  const filterAllActivities = (
    dateInput: string,
    dateRangeStartDate: string,
    dateRangeEndDate: string,
    activityTypeInput: string,
    topicInput: string,
    accreditationSourceInput: string
  ) => {
    var filtered: any;
    var objFilterName = { label: "" };
    var arrFilterToAPply = [];

    //apply date filters
    //push the selected date specific text to the filters text div
    //push the selected date specific itm only iff it is selected from Filters Modal Pop up
    //do not push the selected item if it is removed from the list by end user
    if (dateInput == "Date Range") {
      objFilterName.label =
        "Date: " + dateRangeStartDate + "-" + dateRangeEndDate + "";
      arrFilterToAPply.push(objFilterName);

      //filter result based on date range
      filtered = cpyCMETrackingDetails.filter(
        (data) =>
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) >=
          new Date(dateRangeStartDate) &&
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) <=
          new Date(dateRangeEndDate)
      );
      //update record list
      setCMETrackingDetails(filtered);
    } else if (dateInput == "Last 30 Days") {
      objFilterName.label = "Date: " + dateInput + "";
      arrFilterToAPply.push(objFilterName);

      var today = new Date();
      setfilterdateRangeEndDate(moment(today).format("MM/DD/YYYY"));

      var priorDate = new Date(new Date().setDate(today.getDate() - 30));
      setfilterdateRangeStartDate(moment(priorDate).format("MM/DD/YYYY"));

      //filter result based on date range
      filtered = cpyCMETrackingDetails.filter(
        (data) =>
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) >=
          priorDate &&
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) <= today
      );
      //update record list
      setCMETrackingDetails(filtered);
    } else if (dateInput == "Last 6 Months") {
      objFilterName.label = "Date: " + dateInput + "";
      arrFilterToAPply.push(objFilterName);

      var today = new Date();
      setfilterdateRangeEndDate(moment(today).format("MM/DD/YYYY"));

      var priorDate = new Date(new Date().setDate(today.getDate() - 183));
      setfilterdateRangeStartDate(moment(priorDate).format("MM/DD/YYYY"));

      //filter result based on date range
      filtered = cpyCMETrackingDetails.filter(
        (data) =>
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) >=
          priorDate &&
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) <= today
      );
      //update record list
      setCMETrackingDetails(filtered);
    } else if (dateInput == "Year To Date (YTD)") {
      objFilterName.label = "Date: " + dateInput + "";
      arrFilterToAPply.push(objFilterName);

      var today = new Date();
      setfilterdateRangeEndDate(moment(today).format("MM/DD/YYYY"));

      var priorDate = new Date(new Date(today.getFullYear(), 0, 1));
      setfilterdateRangeStartDate(moment(priorDate).format("MM/DD/YYYY"));

      //filter result based on date range
      filtered = cpyCMETrackingDetails.filter(
        (data) =>
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) >=
          priorDate &&
          new Date(moment(data.CompletionDate).format("MM/DD/YYYY")) <= today
      );
      //update record list
      setCMETrackingDetails(filtered);
    } else if (dateInput == "All Time") {
      setfilterdateRangeEndDate("");
      setfilterdateRangeStartDate("");

      //  objFilterName.label = 'Date: ' +dateInput+''
      //arrFilterToAPply.push(objFilterName)
      filtered = cpyCMETrackingDetails;
      setCMETrackingDetails(cpyCMETrackingDetails);
    } else if (dateInput == "Date Filter Deleted") {
      setfilterdateRangeEndDate("");
      setfilterdateRangeStartDate("");
      filtered = cpyCMETrackingDetails;
      setCMETrackingDetails(cpyCMETrackingDetails);
    }
    objFilterName = { label: "" };

    //apply activity type filters
    //push the selected activity type text in the list of filters text div
    //push the selected activity type specific item only iff it is selected from Filters Modal Pop up
    //do not push the selected item if it is removed from the list by end user
    if (activityTypeInput === "Activity Types Filter Deleted") {
    } else if (activityTypeInput === "All Activity Types") {
      // objFilterName.label = 'Activity Type: '+ activityTypeInput;
      //arrFilterToAPply.push(objFilterName)
    } //this is the condition where user selected the activity type from the list of dropdown
    else if (activityTypeInput !== "All Activity Types") {
      //filter result based on selected activity type
      filtered = filtered.filter(
        (data: any) => data.CME_ActivityType_Id === Number(activityTypeInput)
      );
      //update record list
      setCMETrackingDetails(filtered);

      //this will update the selected activity in the filters div
      var objCMEActityType = cmeActivityTypeList.filter(
        (data) => data.Id === Number(activityTypeInput)
      );
      objFilterName.label = "Activity Type: " + objCMEActityType[0].Name;
      arrFilterToAPply.push(objFilterName);
    }
    objFilterName = { label: "" };

    //apply selected topic filters
    //Here will apply the selected filtes text
    //push the selected topic specific item only iff it is selected from Filters Modal Pop up
    //do not push the selected item if it is removed from the list by end user
    if (topicInput === "Topics Filter Deleted") {
    } else if (topicInput === "All Topics") {
      // objFilterName.label = 'Topic: '+topicInput;
      // arrFilterToAPply.push(objFilterName)
    } //This is the case when user selected the topic list from dropdown
    else if (topicInput !== "All Topics") {
      //filter result based on selected topic
      filtered = filtered.filter((data: any) => {
        return data.CME_Tracking_Details.some(function (element: any) {
          return element.CME_Topic_Id === Number(topicInput);
        });
      });
      //update record list
      setCMETrackingDetails(filtered);

      //This will update the selected topic in the Filters div
      objCMEActityType = cmeTopicList
        .filter((item: any) => item.Id !== -1)
        .filter((data) => data.Id === Number(topicInput));

      objFilterName.label = "Topic: " + objCMEActityType[0].Name;
      arrFilterToAPply.push(objFilterName);
    }

    objFilterName = { label: "" };

    if (accreditationSourceInput === "Accreditation Source Filter Deleted") {
    } else if (accreditationSourceInput === "All Accreditation Sources") {
      // objFilterName.label = 'Accreditation Source: '+ accreditationSourceInput;
      // arrFilterToAPply.push(objFilterName)
    } else if (accreditationSourceInput === "ACEP Accredited") {
      //filter result based on acep Accredited
      filtered = filtered.filter(
        (data: any) => data.AccreditedProvider === "ACEP"
      );
      //update record list
      setCMETrackingDetails(filtered);

      //this will update the selected activity in the filters div
      //var objCMEActityType = (cmeActivityTypeList.filter(data => data.Id === Number(activityTypeInput)))
      objFilterName.label = "Accreditation Source: " + accreditationSourceInput;
      arrFilterToAPply.push(objFilterName);
    } else if (accreditationSourceInput === "Self-Reported") {
      //filter result based on acep Accredited
      filtered = filtered.filter(
        (data: any) =>
          data.AccreditedProvider === null && data.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id
      );
      //update record list
      setCMETrackingDetails(filtered);

      //this will update the selected activity in the filters div
      //var objCMEActityType = (cmeActivityTypeList.filter(data => data.Id === Number(activityTypeInput)))
      objFilterName.label = "Accreditation Source: " + accreditationSourceInput;
      arrFilterToAPply.push(objFilterName);
    }

    objFilterName = { label: "" };

    setSearchListData(filtered);
    //setUpdateData(false)
    setSelectedOption(arrFilterToAPply);

    setLoadNavHeight(true);
    setHeaderCheckUnchekBox(false);
    setDisableReportButtons(true);

    if (searchString !== "" && searchString !== undefined) {
      searchCMETrackingDetails(filtered, searchString);
    }
  };

  //On Remove the Selected Filters
  const handleFiltersRemove = (ev: any, selectedItemToRemove: any) => {
    // setUpdateData(false)
    //ev.preventDefault();
    selectedOption.splice(
      selectedOption.findIndex((object) => {
        return object.label === selectedItemToRemove;
      }),
      1
    );

    setSelectedOption(selectedOption);

    //call filterAllActivities() to apply filetrs
    let itemToRemoveFilter: string =
      selectedItemToRemove.split(":")[0].trim() || "";

    if (itemToRemoveFilter === "Date") {
      setfilterdateInput("Date Filter Deleted");
      itemToRemoveFilter = "Date Filter Deleted";
      filterAllActivities(
        itemToRemoveFilter,
        filterdateRangeStartDate,
        filterdateRangeEndDate,
        filteractivityTypeInput,
        filtertopicInput,
        filteraccrediationsourceInput
      );
    }

    if (itemToRemoveFilter === "Activity Type") {
      setfilteractivityTypeInput("Activity Types Filter Deleted");
      itemToRemoveFilter = "Activity Types Filter Deleted";
      filterAllActivities(
        filterdateInput,
        filterdateRangeStartDate,
        filterdateRangeEndDate,
        itemToRemoveFilter,
        filtertopicInput,
        filteraccrediationsourceInput
      );
    }

    if (itemToRemoveFilter === "Topic") {
      setfiltertopicInput("Topics Filter Deleted");
      itemToRemoveFilter = "Topics Filter Deleted";
      filterAllActivities(
        filterdateInput,
        filterdateRangeStartDate,
        filterdateRangeEndDate,
        filteractivityTypeInput,
        itemToRemoveFilter,
        filteraccrediationsourceInput
      );
    }

    if (itemToRemoveFilter === "Accreditation Source") {
      setfilteraccrediationsourceInput("Accreditation Source Filter Deleted");
      itemToRemoveFilter = "Accreditation Source Filter Deleted";
      filterAllActivities(
        filterdateInput,
        filterdateRangeStartDate,
        filterdateRangeEndDate,
        filteractivityTypeInput,
        filtertopicInput,
        itemToRemoveFilter
      );
    }

    setLoadNavHeight(true);
  };

  //Export Transcript Button Click
  const exportTranscriptButtonClickEvent = (
    ev: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    ev.preventDefault();

    if (claimeStyles.pointer === "auto") {
      //To show the wait indicator
      showSpinner(true);

      const selectedTransRecords = cmeTrackingDetails
        .filter((data) => {
          return data.IsSelected === true;
        })
        .map(({ Id }) => Id.toUpperCase())
        .join(",");

      const selectedTopic = cmeTopicList
        .filter((item: any) => item.Id !== -1)
        .filter((data) => data.Id === Number(filtertopicInput));
      const topicFilter =
        selectedTopic.length > 0 && filtertopicInput !== "All Topics"
          ? selectedTopic[0].Name
          : "All";
      const promise1 = callReportForBufer1("cmetracker_transcript", [
        { name: "ContactId", value: contactData?.contactid },
        {
          name: "CMETrackingId",
          value: selectedTransRecords.length > 0 ? selectedTransRecords : "All",
        },
        { name: "Topic", value: topicFilter },
        {
          name: "StartDate",
          value:
            filterdateRangeStartDate.length > 0
              ? filterdateRangeStartDate
              : "1/1/1900",
        },
        {
          name: "EndDate",
          value:
            filterdateRangeEndDate.length > 0
              ? filterdateRangeEndDate
              : "1/1/2900",
        },
      ]);
      const promieArray = [promise1];
      fetchAsyncData(promieArray, [], "Transcript");
    }
  };

  //On Delete Self Reported Activity Button CLick
  const onDeleteSelfActivityClick =
    (selectedTranscriptRecordID: string, certificateURL: string, listRowIndex: number) =>
      (event: any) => {
        totalAPICalls = 0;
        //To show the wait indicator
        showSpinner(true);

        //This will check user session is active or not
        localStorage.setItem("loadSSOData", "1");
        event.preventDefault();

        //Close the pop up window for admin and normal user
        event.target[1].click();

        //this will delete the self reported activity
        // if (certificateURL && !certificateURL?.toString()?.startsWith("http")) {
        //This will update the CME Tracking record with empty value as CertificateURL
        // let method = 'PUT';
        // let requestOptions = {
        //                         Id: claimCMETrackingId,
        //                         Certificate_url: ""
        // };

        // executeAPI(requestOptions,"cmetracking/"+claimCMETrackingId, method);

        //This will delete the blob
        // var acepid =
        //   userData.acepMemberStatus === 2
        //     ? contactData.acepid
        //     : userData.acepid;
        // const url =
        //   API_URL +
        //   "/deleteBlob/" +
        //   acepid.toLocaleLowerCase() +
        //   "?filepath=" +
        //   certificateURL;
        // axios.delete(url);
        // }
        apiProfiles.url = "CMETracking";

        var queryStringpara =
          selectedTranscriptRecordID +
          "/" +
          userData.firstName +
          " " +
          userData.lastName;

        apiProfiles.remove(queryStringpara).then(() => {
          removeQueries(["claimedCMEFilterData", "claimedCMEData"]);

          msg = "Activity Record Deleted Successfully!";
          setOpenAlertMsg(true);
          //setCurrent("")

          const newCME: any = cmeTrackingDetails.filter(
            (ele) => ele.Id !== selectedTranscriptRecordID
          );
          setCMETrackingDetails(newCME);
        });

        setSelectedRowIndex(listRowIndex);
      };

  //Export Certificate Button Click
  async function exportCertButtonClickEvent(
    ev: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): Promise<void> {
    ev.preventDefault();

    // Check if professional status attestation is required
    let attestationResult: { shouldContinue: boolean; isNonPhysician?: boolean } | null = null;
    if (shouldShowProfessionalStatusPopup()) {
      attestationResult = await showProfessionalStatusPopup();
      if (!attestationResult.shouldContinue) {
        return; // User cancelled, don't proceed with export
      }
    }

    emptyBlobDetails = "";
    if (claimeStyles.pointer === "auto") {
      setUploadedCertificateUrl("");

      setLstSelfReportedNotAvailableCertificates("");
      setDisableExportCertButton(true);
      setToShowExportCertButton(false);
      try {
        //To show the wait indicator
        showSpinner(true);

        const selectedTransRecords = cmeTrackingDetails
          .filter((data) => {
            return (
              data.IsSelected === true &&
              (data.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id && (data.CertificateUrl === "" || data.CertificateUrl === null)) &&
              data.Host !== "ABEM"
            );
          })
          .sort((a, b) => a.Id.localeCompare(b.Id)) //This will sort the records based on Id similar in SQL
          .map(({ Id }) => Id.toUpperCase())
          .join(",");

        const getFileExtension = (url: string) => {
          const match = url?.match(/\.([a-zA-Z0-9]+)$/); // Extract last valid extension
          return match ? match[1].toLowerCase() : null;
        };

        //This will include the Self Reported selected activites + ABEM Selected Activiteis
        //As for ABEM Activities, there is not ACEP Generatd Certificat
        //So it will also consider similar to the Self Reported Activity
        const selectedSelfReportedTransRecordList = cmeTrackingDetails.filter(
          (data) => {
            return (
              (data.IsSelected === true && data.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id) ||
              (data.IsSelected === true &&
                data.CertificateUrl &&
                data.CertificateUrl !== "") ||
              (data.Host === "ABEM" && data.IsSelected === true)
            );
          }
        ).map((data) => {
          const fileExtension = getFileExtension(data.CertificateUrl);
          if (data.CertificateUrl && (!fileExtension || !allowedExtensions.includes(fileExtension))) {
            return { ...data, CertificateUrl: null }; // Remove invalid file URLs
          }
          return data;
        });

        //This will fetch the record list for selected ABEM Activities who do not have any Certificate URL
        selectedABEMTransRecordList = cmeTrackingDetails.filter(
          (data) =>
            data.Host === "ABEM" &&
            data.IsSelected === true &&
            (data.CertificateUrl === null || data.CertificateUrl === "")
        );

        var pattern = /^((http|https|ftp):\/\/)/;

        //This will give the list of records whose Certificate URL is having pdf
        const selectedSelfReportedTransRecords =
          selectedSelfReportedTransRecordList
            .filter(
              (data) => (data.CertificateUrl || "").length > 0 //&& ((data.CertificateUrl||'').toLocaleLowerCase().indexOf(".pdf") !== -1 )
            )
            .map(({ CertificateUrl }) => CertificateUrl)
            .join("<||>");

        //This will get the base64 string for the selected transcript records other than self reported

        let promise1;

        //This is for if user selected non self reported records
        if (selectedTransRecords.length > 0) {
          // Calculate isPhysician based on member status, ABEM certification, and user's saved preference
          let isPhysicianForCert = true; // Default for members
          if (isNonMember(contactData)) {
            // For non-members, use attestation result if just provided, otherwise use current state
            let effectiveNonPhysician;
            if (attestationResult && attestationResult.isNonPhysician !== undefined) {
              effectiveNonPhysician = attestationResult.isNonPhysician;
            } else {
              effectiveNonPhysician = currentSessionNonPhysician !== null ? currentSessionNonPhysician : isNonPhysician;
            }
            isPhysicianForCert = !effectiveNonPhysician;
          }

          promise1 = callReportForBufer1("cmetracker_cert", [
            { name: "CMETrackingId", value: selectedTransRecords },
            { name: "isPhysician", value: isPhysicianForCert.toString() },
          ]).catch((error) => {
            console.log(error);
            //To hide the wait indicator
            showSpinner(false);
          });
        } else promise1 = null;

        //This is for if user selected at least one self reported record
        const promise2 =
          selectedSelfReportedTransRecords.replace(",", "").length > 0
            ? callReportForBufer2(
              selectedSelfReportedTransRecords,
              selectedSelfReportedTransRecordList,
              promise1 === null ? null : []
            ).catch((error) => {
              console.log(error);

              //To hide the wait indicator
              showSpinner(false);
            })
            : null;

        const promieArray = [
          promise1 !== null ? promise1 : "",
          promise2 !== null ? promise2 : "",
        ];

        if (promise1 !== null || promise2 !== null) {
          setToShowExportCertButton(true);
          fetchAsyncData(
            promieArray,
            selectedSelfReportedTransRecordList,
            "Certficate"
          );
        } else {
          //here both the selected activities are eigher not valid or they dont have the self reported certificate for self reported case
          setToShowExportCertButton(false);

          //this will give list of record whose certificateUrl is null or empty
          var ListForNullCert = selectedSelfReportedTransRecordList.filter(
            (data) =>
              data.CertificateUrl === null ||
              (data.CertificateUrl || "").length === 0
          );

          //This will give list of record whose CertificateUrl is not null and non pdf file
          var ListForNotNullCert = selectedSelfReportedTransRecordList.filter(
            (data) =>
              data.CertificateUrl !== null &&
              (data.CertificateUrl || "").length > 0 &&
              (data.CertificateUrl || "")
                .toLocaleLowerCase()
                .indexOf(".pdf") === -1
          );

          //This will show pop up with export button as there is one non pdf url which we need to show in the tab
          if (ListForNullCert.length > 0 && ListForNotNullCert.length > 0) {
            //To hide the wait indicator
            showSpinner(false);

            setToShowExportCertButton(true);
            showMissingCertificateForSelfReportedActivity(
              selectedSelfReportedTransRecordList,
              true
            );
          } else {
            if (ListForNullCert.length > 0) {
              //To hide the wait indicator
              showSpinner(false);

              setToShowExportCertButton(false);
              showMissingCertificateForSelfReportedActivity(
                selectedSelfReportedTransRecordList,
                true
              );
            } else {
              //this will be the case when only other than pdf file - self reported selected for certificate generatins
              selectedSelfReportedTransRecordList
                .filter(
                  (data) =>
                    pattern.test(data.CertificateUrl || "") &&
                    (data.CertificateUrl || "")
                      .toLocaleLowerCase()
                      .indexOf(".pdf") === -1
                )
                .map((data) => {
                  if (data.CertificateUrl && data.CertificateUrl.length > 0)
                    commaSeperatedURLToGenerateZIP.push({
                      fileUrl: data.CertificateUrl,
                      fileName:
                        data.Name +
                        data.CertificateUrl.slice(
                          data.CertificateUrl.lastIndexOf(".")
                        ),
                    });
                });

              if (commaSeperatedURLToGenerateZIP.length > 0) {
                const zip = new JSZip();
                handleConversionToZip(commaSeperatedURLToGenerateZIP, zip);
              }
            }
          }

          // setPageWaitIndicator(false)
        }
      } catch (error) {
        console.log(error);
        //To hide the wait indicator
        showSpinner(false);
      }
    }
  }

  const handleConversionToZip = async (fileURLs: FileData[], zip: JSZip) => {
    try {
      const zipContent = await zip.generateAsync({ type: "blob" });

      //reset the array to empty
      commaSeperatedURLToGenerateZIP = [];

      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(zipContent);
      downloadLink.download = "ACEP_Certificates.zip";
      downloadLink.click();
      //To hide the wait indicator
      showSpinner(false);
    } catch (error) {
      //To hide the wait indicator
      showSpinner(false);
      console.error(error);
    }
  };
  //This will show the pop up based on the self reported record who dont have the certifiate url
  const showMissingCertificateForSelfReportedActivity = (
    selectedSelfReportedTransRecordList: IClaimdDetails[],
    bToShowCertPopup: boolean
  ) => {
    var pattern = /^((http|https|ftp):\/\/)/;
    let certificateURLNames = emptyBlobDetails;

    setLstSelfReportedNotAvailableCertificates("");

    //First case -> Selected Certificates doesnt have any Certificate URL
    //certificateURLNames = certificateURLNames.length > 0 ? certificateURLNames:''

    var certNames = selectedSelfReportedTransRecordList
      .filter(
        (data) =>
          data.CertificateUrl === null || data.CertificateUrl?.length == 0 || data.CertificateUrl === ""
      )
      .map(({ Name }) => Name)
      .join(",");

    if (certNames.length > 0 && certificateURLNames.length > 0)
      certificateURLNames = certNames + "," + certificateURLNames;
    else if (certNames.length > 0) certificateURLNames = certNames;

    setLstSelfReportedNotAvailableCertificates(certificateURLNames);

    if (certificateURLNames.length > 0 || bToShowCertPopup) {
      if (
        selectedSelfReportedTransRecordList.filter(
          (data) =>
            pattern.test(data.CertificateUrl || "") &&
            (data.CertificateUrl || "").toLocaleLowerCase().indexOf(".pdf") ===
            -1
        ).length > 0
      )
        setToShowExportCertButton(true);

      inputElement && inputElement.current.click();
    }

    //Second case -> Selected Self Reported Certificate has one blank Certificate URL and one Certificat Not Available
  };

  //This function will execute the API call with promise
  //once all promise is done then it will merge the data and will print the report
  const fetchAsyncData = async (
    promieArray: any,
    selectedSelfReportedTransRecordList: IClaimdDetails[],
    exportType: string
  ) => {
    const res = await Promise.all(promieArray);

    let bufferArray = [];

    if ((buffer1Data === '' || buffer1Data === null) && (buffer2Data === '' || buffer2Data === null)) {
      showSpinner(false);
      setToShowExportCertButton(false);
      showMissingCertificateForSelfReportedActivity(
        selectedSelfReportedTransRecordList,
        true
      );
    }
    else {
      const raw1 = window.atob(buffer1Data);
      const buffer1 = new Uint8Array(new ArrayBuffer(raw1.length));
      for (let i = 0; i < raw1.length; i++) {
        buffer1[i] = raw1.charCodeAt(i);
      }
      if (buffer1.length > 0) bufferArray.push(buffer1);


      const raw2 = window.atob(buffer2Data);
      const buffer2 = new Uint8Array(new ArrayBuffer(raw2.length));
      for (let i = 0; i < raw2.length; i++) {
        buffer2[i] = raw2.charCodeAt(i);
      }

      if (buffer2.length > 0 && buffer2Data && buffer2Data.length > 0) bufferArray.push(buffer2);

      if (
        bufferArray.length > 0
      )
        if (bufferArray && bufferArray.length > 0)
          createAndDownloadBlobFile(
            bufferArray,
            selectedSelfReportedTransRecordList,
            exportType
          );
      // else {
      //   const doc = await PDFDocument.create();
      //   printPdfToBrowser(doc, selectedSelfReportedTransRecordList, exportType);
      // }
    }
  };


  //This function will execute the API created by ACEP and will get the Blob stream byte of base64 string
  const callReportForBufer2 = (
    selectedSelfReportedTransRecords: string,
    selectedSelfReportedTransRecordList: IClaimdDetails[],
    promise1: [] | null
  ): Promise<string | null> => {
    return new Promise((resolve) => {
      apiUsers.url = "generateSASURLFromBlobList/";
      const acepid =
        userData.acepMemberStatus === 2 ? contactData.acepid : userData.acepid;

      apiUsers
        .post({
          acepid: acepid.toLocaleLowerCase(),
          filepath: selectedSelfReportedTransRecords,
        })
        .then(async (resp: any) => {
          let emptyBlobDetailsSet = new Set<string>();
          const lstBlobURL: (string | null)[] = resp.blobDetails[1] || [];
          const failedBlobURLs = Array.isArray(resp.blobDetails[0])
            ? resp.blobDetails[0] // If it's already an array, use it directly
            : typeof resp.blobDetails[0] === "string"
              ? resp.blobDetails[0].split(",").map(url => url.trim()).filter(url => url) // If it's a string, split it into an array
              : []; // If it's neither, default to an empty array

          // Collect missing certificate names based on failed URLs
          selectedSelfReportedTransRecordList.forEach((record) => {
            if (
              record.CertificateUrl &&
              (failedBlobURLs.includes(record.CertificateUrl)) // Ensure it doesn't exist in valid URLs
            ) {
              emptyBlobDetailsSet.add(record.Name); //for missing certificate for ABEM, below array will be used to decide the language on missing certificate pop up
              if (record.Host && record.Host === "ABEM") selectedABEMTransRecordList.push(record);

            }
          });

          const validBlobURLs = lstBlobURL.filter((url): url is string => url !== null);

          if (validBlobURLs.length > 0) {
            try {
              interface MergeResponse {
                bytes: string;
                failedFiles: string[];
              }

              const mergeResponse = await axios.post<MergeResponse>(
                MERGE_FILE_ENDPOINT_URL,
                {
                  files: validBlobURLs.map((url) => ({ url })),
                },
                {
                  headers: { "Content-Type": "application/json" },
                }
              );

              const mergeData = mergeResponse.data;
              buffer2Data = mergeData.bytes;
              const failedFiles: string[] = mergeData.failedFiles || [];

              // Collect failed file names and match with records
              failedFiles.forEach((failedUrl) => {
                const failedFileName = decodeURIComponent(failedUrl.split("/").pop()?.split("?")[0] || "");
                const failedRecord: any = selectedSelfReportedTransRecordList.find(
                  (data) => data.CertificateUrl === failedFileName || data.CertificateUrl === failedUrl
                );
                if (failedRecord) emptyBlobDetailsSet.add(failedRecord.Name);
                if (failedRecord.Host && failedRecord.Host === "ABEM") selectedABEMTransRecordList.push(failedRecord);
              });
            } catch (error) {
              console.error("Error merging files:", error);
            }
          } else if (promise1 === null && lstBlobURL.every((item) => item === null)) {
            emptyBlobDetails = Array.from(emptyBlobDetailsSet).join(",");

            showMissingCertificateForSelfReportedActivity(
              selectedSelfReportedTransRecordList,
              true
            );

            setToShowExportCertButton(false);
            showSpinner(false);
          }

          emptyBlobDetails = Array.from(emptyBlobDetailsSet).join(",");

          resolve(buffer2Data);
        });
    });
  };


  const callReportForBufer1 = async (
    reportName: string,
    inputParams: { name: string; value: string | undefined }[]
  ) => {
    return new Promise((resolve) => {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: AuthorizationCredentials,
        },
        body: JSON.stringify({
          name: reportName,
          format: "pdf",
          params: inputParams,
        }),
        responseType: "arraybuffer",
        async: false,
      };

      fetch(ReportURL, requestOptions)
        .then((data) => data.text())
        .then(async (data) => {
          buffer1Data = data.slice(1, -1) || "";
          resolve(buffer1Data);
        });
    });
  };

  //This will return the string based on the current date time
  const getFormattedTimestamp = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const second = String(now.getSeconds()).padStart(2, "0");

    return `${year}${month}${day}${hour}${minute}${second}`;
  };

  //This func+tion will print the report based on the data
  // const printPdfToBrowser = async (
  //   doc: PDFDocument,
  //   selectedSelfReportedTransRecordList: IClaimdDetails[],
  //   exportType: string
  // ) => {
  //   //To hide the wait indicator
  //   claimeStyles.showSpinner(false);

  //   if (true) {

  //     const timestamp = getFormattedTimestamp();
  //     const fileName = `${exportType}_${timestamp}.pdf`;
  //     var bBody = await doc.save();
  //     const blob = new Blob([bBody], { type: "application/pdf" });

  //     // Create a File object with additional properties
  //     const pdfFile = new File([blob], fileName, {
  //       lastModified: Date.now(),
  //     });
  //     setPdfFIle(pdfFile)

  //     const blankCertURL = selectedSelfReportedTransRecordList
  //     .filter(
  //       (data) =>
  //         data.CertificateUrl === null || data.CertificateUrl?.length == 0 || data.CertificateUrl === ""
  //     )
  //     .map(({ Name }) => Name)
  //     .join(",");

  //    if((blankCertURL  && blankCertURL.length > 0 )  || (emptyBlobDetails && emptyBlobDetails.length > 0)) {
  //     setToShowExportCertButton(true);

  //     //To hide the wait indicator
  //     showSpinner(false);

  //     showMissingCertificateForSelfReportedActivity(
  //       selectedSelfReportedTransRecordList,        
  //       true
  //     );



  //   }else{
  //     saveAs(pdfFile)
  //   } 

  //   } 
  //   //To clear all the variables used for certificate zip generation
  //   buffer1Data = "";
  //   buffer2Data = "";

  // };

  const printPdfToBrowser = async (
    doc: PDFDocument,
    selectedSelfReportedTransRecordList: IClaimdDetails[],
    exportType: string
  ) => {
    // Hide the spinner
    showSpinner(false);

    const timestamp = getFormattedTimestamp();
    const fileName = `${exportType}_${timestamp}.pdf`;
    const bBody = await doc.save();
    const blob = new Blob([bBody], { type: "application/pdf" });
    const pdfFile = new File([blob], fileName, { lastModified: Date.now() });

    setPdfFIle(pdfFile);

    const pdfURL = URL.createObjectURL(blob);
    setPdfURL(pdfURL);

    const blankCertURL = selectedSelfReportedTransRecordList
      .filter((data) => !data.CertificateUrl || data.CertificateUrl.trim() === "")
      .map(({ Name }) => Name)
      .join(",");

    if (blankCertURL.length > 0 || (emptyBlobDetails && emptyBlobDetails.length > 0)) {
      setToShowExportCertButton(true);
      showSpinner(false);
      showMissingCertificateForSelfReportedActivity(selectedSelfReportedTransRecordList, true);
      return;
    }


    if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1)) {
      // Open PDF in a new tab for iOS (ensuring Share button appears)
      const newTab = window.open(pdfURL, "_blank");
      if (!newTab) {
        // If pop-up blocked, fallback to opening in the same tab
        window.location.href = pdfURL;
      }
    } else {
      saveAs(pdfFile); // Works fine on Android and desktop
    }

    // Clear buffer variables
    buffer1Data = "";
    buffer2Data = "";
  };


  //This function will generate the PDF document from the base64 stream byte data
  async function createAndDownloadBlobFile(
    buffer: Uint8Array[],
    selectedSelfReportedTransRecordList: IClaimdDetails[],
    exportType: string,
    extension = "pdf"
  ) {
    const doc = await PDFDocument.create();

    try {
      //  buffer.sort((a, b) => a.length > b.length ? 1 : -1)
      //To hide the wait indicator
      showSpinner(false);

      const firstBuffer = buffer[0];
      const cover = await PDFDocument.load(firstBuffer, {
        ignoreEncryption: true,
      }).catch();
      if (cover) {
        const PageCover =
          doc && (await doc.copyPages(cover, cover.getPageIndices()).catch());

        if (PageCover && PageCover.length > 0) {
          for (const page of PageCover) {
            doc.addPage(page);
          }
          let remainingBuffer = buffer.splice(1, buffer.length);
          if (remainingBuffer && remainingBuffer.length <= 0) {
            printPdfToBrowser(
              doc,
              selectedSelfReportedTransRecordList,
              exportType
            );
          } else {
            try {
              remainingBuffer &&
                remainingBuffer.forEach(async (element) => {
                  const content = await PDFDocument.load(element, {
                    ignoreEncryption: true,
                  });

                  const PageContent = await doc
                    .copyPages(content, content.getPageIndices())
                    .catch();
                  for (const page of PageContent) {
                    doc.addPage(page);
                  }

                  remainingBuffer = remainingBuffer.splice(
                    1,
                    remainingBuffer.length
                  );

                  if (remainingBuffer.length <= 0) {
                    printPdfToBrowser(
                      doc,
                      selectedSelfReportedTransRecordList,
                      exportType
                    );
                  }
                });
            } catch (error) {
              // printPdfToBrowser(
              //   doc,
              //   selectedSelfReportedTransRecordList,
              //   exportType
              // );
            }
          }
        }
      }
    } catch (error) {

    } finally {
    }
  }

  //For Certificate Upload
  //On File Selectes
  const fileBrowseHandler = (event: any) => {
    const file = event.target.files[0];
    let fileName = file.name;
    const sanitizedFileName = fileName.replace(/[#?&/:\"'\\@+]/g, "_"); // Replace special characters

    let updatedFile = file;

    // Create a new File object if the name was changed
    if (fileName !== sanitizedFileName) {
      updatedFile = new File([file], sanitizedFileName, { type: file.type, lastModified: file.lastModified });
      console.log("New File Created:", updatedFile.name); // Log to verify new name
    }


    if (updatedFile.size <= 5000000 && allowedTypes.includes(file.type)) {
      setInvalidFileMessage(false);
      setUploadedCertificateUrl(updatedFile.name); // Use sanitized name
      setSelectedFile(updatedFile); // Use the new File object
      setFormDirty(true);
    } else {
      setInvalidFileMessage(true);
      setUploadedCertificateUrl("");
      setSelectedFile("");
    }
  };


  const postFile = async (): Promise<string> => {
    const file: any = selectedfile;

    //on selection, this field alredy available
    const fileName = UploadedCertificateUrl;
    const acepid =
      userData.acepMemberStatus === 2
        ? contactData.acepid.toLocaleLowerCase()
        : userData.acepid.toLocaleLowerCase();

    if (file && fileName && fileName.length > 0) {
      const formdata = new FormData();
      formdata.append("file", file);
      // formdata.append("acepid",acepid)

      let requestOptions = {
        method: "POST",
        type: "formData",
        body: formdata,
      };

      try {
        const res = await axios.post(API_URL + "/uploadBlob/" + acepid, formdata);
        // Assert the type of res.data to UploadResponse
        const data = res.data as any;
        return data.blobName; // Return the blobName
      } catch (error) {
        setUploadedCertificateUrl("");
        console.error("Error uploading file:", error);
        return ""; // Handle error case
      }
    } else {
      setUploadedCertificateUrl('')
      console.log("Please select file");
      return "";
    }
  };

  //On click of Blob name, this function will get call
  //This will get the BLOB SRS URL and will load the blob file in the browser in the new tab
  const getBlobAndDisplay = (ev: any, blobName: any) => {
    ev.preventDefault();

    if (blobName.toString().startsWith("http")) {
      window.open(blobName, "_blank", "noreferrer");
    } else {
      var acepid =
        userData.acepMemberStatus === 2 ? contactData.acepid : userData.acepid;
      apiUsers.url =
        "getUploadedBlobURL/" +
        acepid.toLocaleLowerCase() +
        "?filepath=" +
        blobName;
      apiUsers.getAll().then((resp: any) => {
        resp &&
          resp.BlboURL &&
          window.open(resp.BlboURL, "_blank", "noreferrer");
      });
    }
  };

  //On click of Blob Close, Delete Pop up will show and on submit button of Pop up, this function will get call
  //This will delete the self reported blob from azure container
  const deleteSelfReportedBlob = (blobName: any) => (event: any) => {

    event.preventDefault();
    setUploadedCertificateUrl("");

    //When user uploaded certificate bur cancel
    if (blobName.length <= 0) {
      event.target[1].click();
    } else {
      //To show the wait indicator
      showSpinner(true);

      event.target[1].click();
      //This will update the CME Tracking record with empty value as CertificateURL
      let method = "PUT";
      let requestOptions = {
        Id: claimCMETrackingId,
        Certificate_url: "",
      };

      totalAPICalls = 1;
      executeAPI(requestOptions, "cmetracking/" + claimCMETrackingId, method);

      //This will delete the blob
      var acepid =
        userData.acepMemberStatus === 2 ? contactData.acepid : userData.acepid;
      const url =
        API_URL +
        "/deleteBlob/" +
        acepid.toLocaleLowerCase() +
        "?filepath=" +
        blobName;
      axios.delete(url).then((res) => {
        console.log("blob deleted successfully");

        //To hide the wait indicator
        // claimeStyles.showSpinner(false)
      });
    }
  };

  const onSubmitCertificates = (event: any) => {
    event.preventDefault();
    event.target[1].click();

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1)) {
      // Open PDF in a new tab for iOS (ensuring Share button appears)
      const newTab = window.open(pdfURL, "_blank");
      if (!newTab) {
        // If pop-up blocked, fallback to opening in the same tab
        window.location.href = pdfURL;
      }
    } else {
      saveAs(pdfFile); // Works fine on Android and desktop
    }

    setPdfFIle("");
  };

  const handleRedirection = (targetPath: string) => {
    // Replace with the path of your target page
    //let targetPath = '/dashboard/MostRecentActivities';

    if (isAdmin && targetPath !== "/") {
      targetPath = targetPath + "?acepid=" + contactData.acepid;
    }

    // Use the history object to navigate to the target page with state
    // history.push({
    //   pathname: targetPath,
    //   state: contactData,
    // });

    history.push(targetPath, { contact: contactData, from: "AdminDashboard" });
  };

  function handleClick(target: any) {
    if (target === "Date") {
      if (order.Date === "asc") {
        setOrder({
          Date: "desc",
          Name: order.Name,
        });

        const sortedAscending = cmeTrackingDetails.sort(
          (a, b) =>
            new Date(a.CompletionDate).valueOf() -
            new Date(b.CompletionDate).valueOf()
        );

        setCMETrackingDetails(sortedAscending);
      } else {
        setOrder({
          Date: "asc",
          Name: order.Name,
        });

        const sortedDescending = cmeTrackingDetails.sort(
          (a, b) =>
            new Date(b.CompletionDate).valueOf() -
            new Date(a.CompletionDate).valueOf()
        );

        setCMETrackingDetails(sortedDescending);
      }
    } else if (target === "Name") {
      if (order.Name === "asc") {
        setOrder({
          Date: order.Date,
          Name: "desc",
        });

        const sortedAscending = cmeTrackingDetails.sort((a, b) =>
          a.Name + a.Details > b.Name + b.Details ? 1 : -1
        );

        setCMETrackingDetails(sortedAscending);
      } else {
        setOrder({
          Date: order.Date,
          Name: "asc",
        });

        const sortedDescending = cmeTrackingDetails.sort((a, b) =>
          a.Name + a.Details < b.Name + b.Details ? 1 : -1
        );

        setCMETrackingDetails(sortedDescending);
      }
    }
  }

  //This function will get call on click of Search button
  //This will filter the CME Tracking details based on the search criteria
  function searchCMETrackingDetails(list: any, value: any) {
    const searchValue = value;
    setSearchString(searchValue);
    const filteredCMETrackingDetails = list.filter(
      (data: { Name: string; Details: string }) => {
        return (
          data.Name?.toLowerCase().includes(searchValue.toLowerCase()) ||
          data.Details?.toLowerCase().includes(searchValue.toLowerCase())
        );
      }
    );
    setCMETrackingDetails(filteredCMETrackingDetails);
    setLoadNavHeight(true);
  }

  function getArrow(order: string) {
    console.log("showSelfReportedActivity", showSelfReportedActivity);
    if (order === "asc")
      return (
        <div className="tracking-sort-arrow">
          <ArrowDownwardIcon fontSize="small" htmlColor="#8B8B8B" />{" "}
        </div>
      );
    return (
      <div className="tracking-sort-arrow">
        {" "}
        <ArrowUpwardIcon fontSize="small" htmlColor="#8B8B8B" />{" "}
      </div>
    );
  }

  return (
    <>
      {pageWaitIndicator && <div className="spinner"> </div>}
      <div className={pageWaitIndicator ? "pageWaitIndicator" : ""}>
        <div
          className={
            isAdmin
              ? "UnclaimedDashboard HomePagebackground adminView"
              : "UnclaimedDashboard HomePagebackground"
          }
          style={{
            pointerEvents: claimeStyles.pointer,
            opacity: claimeStyles.opacity,
            paddingBottom: "15px",
          }}
        >
          <div className="HomePageWrapper ">
            <div className="flaot_left_with_width">
              <LeftNavMenu
                nonmember={
                  (userData.acepMemberStatus === 0 &&
                    userData.sempaMemberStatus !== 15) ||
                    userData.acepMemberStatus === 3 ||
                    userData.acepMemberStatus === 4 ||
                    userData.acepMemberStatus === 7
                    ? 1
                    : 0
                }
                heightDashboardPage={height}
                onCollapse={(isNavExpanded: any) => {
                  setIsNavExpanded(isNavExpanded);
                }}
              />
            </div>

            <div
              ref={ref}
              className={
                isNavExpanded
                  ? "Right-Div-Dashboard-expanded overlay"
                  : "Right-Div-individual-Dashboard"
              }
            >
              {!showSelfReportedActivity && (
                <>
                  {(isAdmin || !isNonPhysician) ? (
                    <div className="column-full">
                      <div className="ContactInfo">
                        <LearnerProfileHeader onLicensesLoaded={(data) => setLicenses(data)} />
                      </div>
                    </div>
                  ) : null}

                  {props_Input ? (
                    <div className="UncalimedDashboard-Heading unclaimed_header_height">
                      <div className="div-left">Unclaimed CME Hours</div>
                      <div className="div-right-Unclaimed-Dashboard">
                        <div
                          className="Unclaimed-CME_Dashboard-right-button"
                          style={{
                            color: enableTranscript,
                            display: "table-cell",
                          }}
                        >
                          {cmeTrackingDetails.length !== 0 ? (
                            <BrowserRouter>
                              <Link
                                component="a"
                                color={enableTranscript}
                                underline="hover"
                                data-analytics="Get Transcript"
                                onClick={() => {
                                  SetCursorToTop();
                                  handleRedirection(
                                    "/dashboard/MostRecentActivities"
                                  )
                                }
                                }
                                sx={{ cursor: "pointer" }}
                              >
                                Get Transcript{" "}
                              </Link>
                            </BrowserRouter>
                          ) : (
                            <BrowserRouter>
                              <Link color={enableTranscript} underline="hover" data-analytics="Get Transcript">
                                Get Transcript{" "}
                              </Link>
                            </BrowserRouter>
                          )}
                          <ArrowForwardIcon style={{ verticalAlign: "top" }} />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="UncalimedDashboard-Heading transcript_header_height">
                      <div>Most Recent CME Activities</div>
                      <div className="SearchBar">
                        <TextField
                          size="small"
                          className="search-box"
                          helperText={false}
                          label="Search by keyword"
                          InputProps={{
                            classes: {
                              focused: "search-inside-div",
                              // because i used variant="outlined" i can pass any classes here that the OutlinedInput uses
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <SearchIcon color="disabled" />
                              </InputAdornment>
                            ),
                          }}
                          onChange={(e) => {
                            searchCMETrackingDetails(
                              searchListData,
                              e.target.value
                            );
                          }}
                          //fullWidth= {true}
                          sx={{ width: "100%", borderRadius: "50px" }}
                        />
                      </div>
                      <div className="paddingTop_20_px">
                        {cmeTrackingDetails.length !== 0 ? (
                          <>
                            <div className="float-left padding-left-10-px">
                              <Button
                                variant="outlined"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  setShowSelfReportedActivity(true);
                                  // history.push({
                                  //     pathname: '/dashboard/SelfReported',
                                  //     state: contactData,
                                  //   });
                                  SetCursorToTop();
                                  handleRedirection("/dashboard/SelfReported");
                                  //this will adjust the height of left nav on dashboard
                                  // setLoadNavHeight(true)
                                }}
                                className="self-transcript-button add_self_reported_activity_button_div"
                                data-analytics="Add Self-Reported CME"
                              >
                                <b className="header-buttons-nowrap add-self-reported-cme">
                                  Add
                                </b>
                                <b className="header-buttons-nowrap">
                                  Self-Reported CME
                                </b>
                              </Button>
                            </div>

                            <div className="float-right padding-left-10-px">
                              <Button
                                variant="outlined"
                                onClick={(ev) => exportCertButtonClickEvent(ev)}
                                style={{
                                  opacity: disableReportButtons ? "0.4" : "1",
                                  pointerEvents: disableReportButtons
                                    ? "none"
                                    : "auto",
                                }}
                                className={
                                  "export-transcript-button export_certificate_button_div model-submit-button-border"
                                }
                                data-analytics="Export Certificate"
                              >
                                <b className="color_white header-buttons-nowrap add-self-reported-cme">
                                  Export
                                </b>
                                <b
                                  className={
                                    "color_white header-buttons-nowrap"
                                  }
                                >
                                  Certificate
                                </b>
                              </Button>
                            </div>

                            <div className="float-right padding-left-10-px">
                              <Button
                                variant="outlined"
                                onClick={(ev) => {
                                  exportTranscriptButtonClickEvent(ev);
                                }}
                                style={{
                                  opacity: disableReportButtons ? "0.4" : "1",
                                  pointerEvents: disableReportButtons
                                    ? "none"
                                    : "auto",
                                }}
                                className={
                                  "export-transcript-button export_certificate_button_div model-submit-button-border"
                                }
                                data-analytics="Export Transcript"
                              >
                                <b className="color_white header-buttons-nowrap add-self-reported-cme">
                                  Export
                                </b>
                                <b
                                  className={
                                    "color_white header-buttons-nowrap"
                                  }
                                >
                                  Transcript
                                </b>
                              </Button>
                            </div>

                            <div className="float-right padding-left-10-px">
                              {
                                //Find index of specific object using findIndex method.

                                <Container
                                  modalFor="Filters"
                                  triggerText="Filters"
                                  modalHeaderText="Filters"
                                  filterProps={[
                                    {
                                      cmeTopicList: cmeTopicList.filter(
                                        (item: any) => item.Id !== -1 && item.ShowFieldOnUI
                                      ),
                                    },
                                    {
                                      toShowSelectFiltersDateRange:
                                        toShowSelectFiltersDateRange,
                                    },
                                    { onchangeDateRange: onchangeDateRange },
                                    {
                                      cmeActivityTypeList: cmeActivityTypeList.filter(
                                        item => item && !EXCLUDED_LIST_OF_ACTIVITY_TYPES.includes(item.Name)
                                      )
                                    },
                                    {
                                      disableReportButtons:
                                        disableReportButtons,
                                    },
                                  ]}
                                  onSubmit={onSubmitFiltersOption}
                                // closeModal={props.closeModal}
                                />
                              }
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="float-left padding-left-10-px">
                              <Button
                                variant="outlined"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  setShowSelfReportedActivity(true);
                                  SetCursorToTop();
                                  handleRedirection("/dashboard/SelfReported");
                                  //this will adjust the height of left nav on dashboard
                                  // setLoadNavHeight(true)
                                }}
                                className="self-transcript-button add_self_reported_activity_button_div"
                              >
                                <b className="header-buttons-nowrap add-self-reported-cme">
                                  Add
                                </b>
                                <b className="header-buttons-nowrap">
                                  Self-Reported CME Activity
                                </b>
                              </Button>
                            </div>

                            <div className="float-right padding-left-10-px">
                              <Button
                                variant="outlined"
                                onClick={(ev) => exportCertButtonClickEvent(ev)}
                                style={{
                                  opacity: disableReportButtons ? "0.4" : "1",
                                  pointerEvents: disableReportButtons
                                    ? "none"
                                    : "auto",
                                }}
                                className={
                                  "export-transcript-button export_certificate_button_div model-submit-button-border"
                                }
                                data-analytics="Export Certificate"
                              >
                                <b className="color_white header-buttons-nowrap add-self-reported-cme">
                                  Export
                                </b>
                                <b
                                  className={
                                    "color_white header-buttons-nowrap"
                                  }
                                >
                                  Certificate
                                </b>
                              </Button>
                            </div>

                            <div className="float-right padding-left-10-px">
                              <Button
                                variant="outlined"
                                onClick={(ev) => {
                                  exportTranscriptButtonClickEvent(ev);
                                }}
                                style={{
                                  opacity: disableReportButtons ? "0.4" : "1",
                                  pointerEvents: disableReportButtons
                                    ? "none"
                                    : "auto",
                                }}
                                className={
                                  "export-transcript-button export_certificate_button_div model-submit-button-border"
                                }
                                data-analytics="Export Transcript"
                              >
                                <b className="color_white header-buttons-nowrap add-self-reported-cme">
                                  Export
                                </b>
                                <b
                                  className={
                                    "color_white header-buttons-nowrap"
                                  }
                                >
                                  Transcript
                                </b>
                              </Button>
                            </div>

                            <div className="float-right padding-left-10-px">
                              <Button
                                variant="outlined"
                                style={{
                                  width: "92px",
                                  opacity: disableReportButtons ? "0.4" : "1",
                                  pointerEvents: disableReportButtons
                                    ? "none"
                                    : "auto",
                                }}
                                className="cancel-transcript-button"
                              >
                                <b> Filters</b>
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      display: FEATURE_Phase_1_MERGE_CME ? "flex" : "none",
                      flexWrap: "wrap",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: "10px",
                      marginBottom: showPhysicianToggle ? "10px" : "0px"
                    }}
                  >
                    <div className="mergeActivitiesNotice" style={{
                      flex: "1",
                      minWidth: "0",
                      margin: "0",
                      padding: "0",
                      paddingBottom: "10px",
                      lineHeight: "normal",
                      fontSize: "inherit"
                    }}>
                      If your ACEP account has been merged, you may notice
                      duplicate CME activities. Please be sure to review for
                      accuracy.
                    </div>
                    {/* IsNonPhysician Toggle: Show only for Non-Members who are not ABEM certified and only on Transcript Dashboard */}
                    {showPhysicianToggle && !props_Input && (
                      <div style={{
                        flexShrink: "0",
                        margin: "0",
                        paddingTop: "10px",
                        alignSelf: "flex-start"
                      }}>
                        <Container
                          modalFor="ProfessionalStatus"
                          triggerText="Update my certificate type"
                          modalHeaderText="Do you require a physician certificate or other healthcare provider certificate?"
                          modalDetailsText=""
                          currentProfessionalStatus={!isNonPhysician ? 'physician' : 'healthcare'}
                          isFirstTimeAttestation={!contactData?.SelfAttestationUpdatedAt}
                          onSubmit={async (selectedStatus: any, closeModal: () => void, event: any) => {
                            // Close modal immediately
                            const closeButton = document.querySelector('._modal-close');
                            if (closeButton) {
                              (closeButton as HTMLElement).click();
                            }

                            // Show wait indicator
                            showSpinner(true);

                            try {
                              const updatedNonPhysician = await handleIsNonPhysicianToggle(selectedStatus);
                              setCurrentSessionNonPhysician(updatedNonPhysician);

                              // Mark that user has attested in this session
                              setHasAttestedThisSession(true);

                              // Resolve the promise if we're waiting for professional status attestation
                              if (professionalStatusResolver) {
                                professionalStatusResolver({ shouldContinue: true, isNonPhysician: updatedNonPhysician }); // Continue with export
                                setProfessionalStatusResolver(null); // Clear the resolver
                              }
                            } finally {
                              // Hide wait indicator when done
                              showSpinner(false);
                            }
                          }}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
              {!showSelfReportedActivity &&
                toShowSelectFiltersDiv &&
                selectedOption &&
                selectedOption.length > 0 && (
                  <div
                    className="filters_header_height"
                    style={{ border: "none" }}
                  >
                    {selectedOption.map((filterOptions, index) => {
                      return (
                        <div
                          key={index}
                          className="filters-button"
                          style={{
                            float: "left",
                            width: "auto",
                            marginRight: "15px",
                          }}
                        >
                          <Button
                            className="model-submit-button"
                            style={{
                              pointerEvents: "none",
                              height: "32px",
                              width: "auto",
                              textTransform: "none",
                              transition: "none !important",
                              color: "black",
                            }}
                          >
                            <span className="filtersText">
                              {" "}
                              {filterOptions.label}{" "}
                            </span>
                          </Button>
                          <span
                            onClick={(ev) =>
                              handleFiltersRemove(ev, filterOptions.label)
                            }
                          >
                            <CloseIcon
                              style={{ color: "black", display: "grid" }}
                            />
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}

              {showSelfReportedActivity ? ( //true  : records will display correctly if they have any
                <div className="EmptyList">
                  {!spinner &&
                    cmeTrackingDetails.length === 0 &&
                    cmeTrackingDetails && (
                      <>
                        <div className="empty-text">
                          You do not have
                          {propsSource === "Unclaimed"
                            ? " any unclaimed CME hours."
                            : " any CME activities."}
                        </div>
                        <div>
                          <img
                            src={
                              propsSource === "Unclaimed"
                                ? EmptyUnclaimedImg
                                : EmptyActivityImg
                            }
                          ></img>
                        </div>
                        <div>
                          <Button
                            style={{ textTransform: "none" }}
                            variant="contained"
                            className="explore-more-opp-div"
                            onClick={redirectEducation}
                          >
                            <b> Explore Opportunities</b>
                          </Button>
                        </div>
                      </>
                    )}
                </div>
              ) : (
                <></>
              )}
              {/*  YT : condition added  : For Claime CME and Transcript UI side   */}
              {cmeTrackingDetails.length === 0 && !showSelfReportedActivity ? (
                <div className="EmptyList">
                  {!spinner &&
                    cmeTrackingDetails.length === 0 &&
                    cmeTrackingDetails && (
                      <>
                        <div className="empty-text">
                          You do not have
                          {propsSource === "Unclaimed"
                            ? " any unclaimed CME hours."
                            : " any CME activities."}
                        </div>
                        <div>
                          <img
                            src={
                              propsSource === "Unclaimed"
                                ? EmptyUnclaimedImg
                                : EmptyActivityImg
                            }
                          ></img>
                        </div>
                        <div>
                          <Button
                            style={{ textTransform: "none" }}
                            variant="contained"
                            className="explore-more-opp-div"
                            onClick={redirectEducation}
                          >
                            <b> Explore Opportunities</b>
                          </Button>
                        </div>
                      </>
                    )}
                </div>
              ) : (
                <></>
              )}

              {!showSelfReportedActivity && showData && (
                <>
                  {cmeTrackingDetails && cmeTrackingDetails.length > 0 ? (
                    <div
                      className={
                        props_Input
                          ? "Unclaimed-dashboard-secondColumn box-style unclaimed_top_margin"
                          : "Unclaimed-dashboard-secondColumn box-style transcript_top_margin"
                      }
                    >
                      <div className="Unclaimed-Dashboard-header-line">
                        {!props_Input && (
                          <div className="paddingTop_25_px flaot_left transcript_header_checkboxColumn_div">
                            <input
                              onChange={(ev) => {
                                setHeaderCheckUnchekBox(ev.target.checked);

                                //this will execute when user checked/unchecked header checkbox only so other child checkbox should also checked/unchecied
                                if (handleHeaderCheckEvent) {
                                  const newCME: any = cmeTrackingDetails.map(
                                    (resData) => {
                                      return {
                                        ...resData,
                                        IsSelected: ev.target.checked,
                                      };
                                    }
                                  );

                                  setCMETrackingDetails(newCME);

                                  setDisableReportButtons(!ev.target.checked);
                                }
                              }}
                              type="checkbox"
                              checked={headerCheckUncheckBox}
                              className="transcript_header_checkxox_control"
                            ></input>
                          </div>
                        )}
                        <div
                          className="box-inner-header unclaim-dateColumn"
                          onClick={() => handleClick("Date")}
                        >
                          Date {getArrow(order.Date)}
                        </div>

                        <div
                          className={
                            props_Input
                              ? "box-inner-header unclaim-eventColumn"
                              : "box-inner-header transcript-eventColumn"
                          }
                          onClick={() => handleClick("Name")}
                        >
                          Activity Name
                          {getArrow(order.Name)}
                        </div>
                        {/* Transcript only: rendered first so float:right places it rightmost,
                            after CME Hours Earned which floats to its left */}
                        {!props_Input && FEATURE_ACCREDITATION_ENABLED && (
                          <div className="box-inner-header transcript-accepted-boards-header">
                            <span className="transcript-boards-label-full">Accepted by Boards</span>
                            <span className="transcript-boards-label-short">Boards</span>
                          </div>
                        )}
                        <div
                          className={
                            props_Input
                              ? "box-inner-header delete-activity"
                              : FEATURE_ACCREDITATION_ENABLED
                                ? "box-inner-header unclaim-maxHoursColumn"
                                : "box-inner-header unclaim-maxHoursColumn unclaim-maxHoursColumn--no-pars"
                          }
                        >
                          {!props_Input ? (
                            FEATURE_ACCREDITATION_ENABLED ? (
                              <>
                                <span className="transcript-hours-label-full">CME Hours Earned</span>
                                <span className="transcript-hours-label-short">Hours Earned</span>
                              </>
                            ) : "CME Hours Earned"
                          ) : ""}
                        </div>
                        {props_Input && (
                          <div className="box-inner-header unclaim-deadline-column">
                            <span className="deadline-col-label-full">Deadline to Claim CME</span>
                            <span className="deadline-col-label-short">Claim By</span>
                          </div>
                        )}
                        {props_Input && (
                          <div className="box-inner-header unclaim-maxHoursColumn-admin">
                            <span className={props_Input + ""}>
                              Max Hours{" "}
                              <span className="max-hours-title-admin">To Claim</span>{" "}
                            </span>
                          </div>
                        )}
                      </div>
                      <List sx={{ bgcolor: "background.paper" }}>
                        {cmeTrackingDetails.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className={"list_row_" + index + (item.IsExpand ? " dvMostRecentList nohover list_main_div" : " dvMostRecentList list_main_div")
                              }
                              onClick={(event) => {
                                // Only call dvShowHideAccordianDetails if the click is not from a select element
                                var selectedElement = event.target as HTMLElement;
                                if (!selectedElement?.closest('select') && !selectedElement?.closest('input')) {
                                  dvShowHideAccordianDetails(event, item, index);
                                }
                              }}
                            >
                              <ListItem
                                key={index}
                                className="lstUnclaimed"
                                alignItems="flex-start"
                                sx={{ width: "100%" }}
                              >
                                <ListItemText
                                  key={index}
                                  className="padding_0_percent"
                                  primary={
                                    <React.Fragment>
                                      {!props_Input && (
                                        <Typography
                                          component="div"
                                          className="transcript_input_checkbox_div_row"
                                        >
                                          <input
                                            onChange={(ev) => {
                                              let bFlagForHeaderCheckBox = true;

                                              setHeaderCheckUnchekBox(false);
                                              const newCME: any =
                                                cmeTrackingDetails.map(
                                                  (resData) => {
                                                    if (
                                                      resData.Id.toLocaleLowerCase() ==
                                                      ev.target.id.toLocaleLowerCase()
                                                    ) {
                                                      return {
                                                        ...resData,
                                                        IsSelected:
                                                          ev.target.checked,
                                                      };
                                                    } else {
                                                      if (
                                                        typeof resData.IsSelected ==
                                                        "undefined" ||
                                                        resData.IsSelected ===
                                                        false
                                                      ) {
                                                        bFlagForHeaderCheckBox =
                                                          false;
                                                      }
                                                      return {
                                                        ...resData,
                                                        IsSelected:
                                                          resData.IsSelected,
                                                      };
                                                    }
                                                  }
                                                );
                                              setCMETrackingDetails(newCME);

                                              if (
                                                bFlagForHeaderCheckBox &&
                                                ev.target.checked
                                              ) {
                                                setHeaderCheckUnchekBox(true);
                                              }

                                              //This will return count of selected check boxes
                                              //based on we can enable/disable the checkbox buttons
                                              const count = newCME.filter(
                                                (obj: { IsSelected: any }) => {
                                                  if (obj.IsSelected) {
                                                    return true;
                                                  }
                                                  return false;
                                                }
                                              ).length;

                                              setDisableReportButtons(
                                                count > 0 ? false : true
                                              );
                                            }}
                                            checked={
                                              item.IsSelected
                                                ? item.IsSelected
                                                : false
                                            }
                                            className="transcript_input_checkbox_control"
                                            type="checkbox"
                                            id={item.Id}
                                          ></input>
                                        </Typography>
                                      )}

                                      <Typography
                                        component="div"
                                        className={`unclaim-dateRow${isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate) ? ' expired-activity-row-text' : ''}`}
                                      >
                                        {item.FormatCompletionDate}
                                      </Typography>

                                      <Typography
                                        component="div"
                                        className={`unclaim-eventRow${isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate) ? ' expired-activity-row-text' : ''}`}
                                      >
                                        {item.Name}{" "}
                                        {item.Details &&
                                          item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id
                                          ? "-" + item.Details
                                          : ""}
                                        {item.CME_Tracking_Status_Id == SelfReported_CME_Tracking_Status_Id && (
                                          <span className="text-color-red">
                                            *
                                          </span>
                                        )}
                                      </Typography>
                                      <Typography
                                        component="div"
                                        className={`${
                                          props_Input
                                            ? "unclaim-maxHoursRow-admin"
                                            : FEATURE_ACCREDITATION_ENABLED
                                              ? "transcript-maxHoursRow"
                                              : "transcript-maxHoursRow transcript-maxHoursRow--no-pars"
                                        }${isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate) ? ' expired-activity-row-text' : ''}`}
                                      >
                                        {item.RemainingHoursToClaim}
                                      </Typography>

                                      {!props_Input && FEATURE_ACCREDITATION_ENABLED && (() => {
                                        const acceptedBoardsLabel = getAcceptedBoardsLabel(item);
                                        if (!acceptedBoardsLabel) return null;
                                        return (
                                          <Typography component="div" className="transcript-accepted-boards-row">
                                            {acceptedBoardsLabel}
                                          </Typography>
                                        );
                                      })()}

                                      {false && (props_Input || isAdmin) && (
                                        <Typography
                                          component="div"
                                          className="unclaim-claimRow-delete"
                                        >
                                          <span className="span-margin-left-delete">
                                            {
                                              <DeleteCMEActivity
                                                onSubmit={onDeleteSelfActivityClick(
                                                  item.Id,
                                                  item.CertificateUrl,
                                                  index,
                                                )}
                                              />
                                            }
                                          </span>
                                        </Typography>
                                      )}

                                      {props_Input && (
                                      <Typography
  component="div"
  className={`unclaim-deadlineRow${
    isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate)
      ? ' expired-activity-row-text'
      : showDeadlineDateRed(item.ActivityTypeName, item.FormatActivityEndDate)
        ? ' text-color-red'
        : ''
  }`}
>
  {!isLiveActivity(item.ActivityTypeName) ? (
    isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate)
      ? 'Expired'
      : (item.FormatActivityEndDate || '')
  ) : ''}
</Typography>
                                      )}

                                      <Typography
                                        component="div"
                                        className="unclaim-claimRow-admin"
                                      >
                                        <span className="span-margin-left">
                                          {item.IsExpand ? (
                                            <ExpandLess />
                                          ) : (
                                            <ExpandMore />
                                          )}
                                        </span>
                                      </Typography>
                                    </React.Fragment>
                                  }
                                />
                              </ListItem>

                              {current === item.Id ? (
                                <div
                                  className={`${
                                    props_Input
                                      ? "TranscriptCMEDashboard-inner-details"
                                      : "ClaimCMEDashboard-inner-details"
                                  }${item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id ? " self-reported-activity" : ""}`}
                                  style={{
                                    marginLeft: true ? "" : "56px",
                                  }}
                                >
                                  <div
                                    style={{ padding: "10px 0px 0px 20px" }}
                                    className="claim-cme-heading"
                                  >
                                    {props_Input
                                      ? (isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate) ? "Activity Expired" : "Claim CME Hours")
                                      : "Edit CME Activity"}
                                  </div>

                                  {props_Input && isActivityExpired(item.ActivityTypeName, item.FormatActivityEndDate) ? (
                                    <div className="pars-expired-activity-notice">
                                      <p className="pars-expired-message-text">
                                        <span className="pars-expired-icon" role="img" aria-label="warning">⚠️</span>
                                        <span>{` Claim window closed on ${item.FormatActivityEndDate}.`}
                                        {/* {(FEATURE_ACCREDITATION_ENABLED && !isNonPhysician && isMDorDO && contactData?.PARSConsentAccepted)
                                          ? ' CME credits can no longer be claimed or submitted to PARS.'
                                          : ' CME credits can no longer be claimed or submitted to state licensing boards.'} */}
                                        </span>
                                      </p>
                                     <div className="expiredDeleteActivity"> <DeleteSelfReportedActivity
                                        onSubmit={onDeleteSelfActivityClick(
                                          item.Id,
                                          item.CertificateUrl,
                                          index,
                                        )}
                                      /> </div>
                                    </div>
                                  ) : (<>

                                  {item.CME_Tracking_Status_Id == SelfReported_CME_Tracking_Status_Id && ( //YT  condition for selfreported activity
                                    <>
                                      <div className="SelfReported-box ">
                                        <div
                                          style={{
                                            paddingRight: "20px",
                                            width: "100%",
                                          }}
                                          className="most-recent-activity-type-box-left-div"
                                        >
                                          {item.CME_Tracking_Status_Id == SelfReported_CME_Tracking_Status_Id && (
                                            <span className="cme-hours-label">
                                              Activity Name
                                            </span>
                                          )}

                                          <input
                                            required
                                            value={currentActivity}
                                            onChange={(event) =>
                                              handleActivityNameChange(event)
                                            }
                                            type="text"
                                            className={
                                              currentActivity === null ||
                                                currentActivity.trim() === ""
                                                ? "cme-activity-input-box float_left error-cme-topic-hours-box "
                                                : "cme-activity-input-box float_left "
                                            }
                                          />

                                          {currentActivity === null ||
                                            (currentActivity.trim() === "" && (
                                              <div className="error-message-cme-hours">
                                                <span className="padding_top_5_px">
                                                  <ErrorIcon />{" "}
                                                  {"This field is required"}
                                                </span>
                                              </div>
                                            ))}
                                        </div>
                                      </div>

                                      <div className="SelfReported-box ">
                                        <div className="most-recent-activity-type-box-left-div">
                                          <span className="cme-hours-label">
                                            Activity Type
                                          </span>

                                          <select
                                            className={
                                              currentActivitytype?.length === 0
                                                ? "input-box error-cme-topic-hours-box   "
                                                : "input-box"
                                            }
                                            value={currentActivitytype}
                                            onChange={(event) =>
                                              handleActivityType(event)
                                            }
                                          >
                                            {cmeActivityTypeList &&
                                              cmeActivityTypeList
                                                .filter(
                                                  (item) => {
                                                    return item &&
                                                      (!EXCLUDED_LIST_OF_ACTIVITY_TYPES.includes(item.Name) ||
                                                        item.Id === currentActivitytype)
                                                  })
                                                .map(
                                                  (data: any) => (
                                                    <>
                                                      {/* <option
                                                    key={shortid.generate()}
                                                    value=""
                                                    defaultValue=""
                                                    disabled
                                                    hidden
                                                  ></option> */}
                                                      <option
                                                        key={shortid.generate()}
                                                        value={data.Id}
                                                      >
                                                        {data.Name}
                                                      </option>
                                                    </>
                                                  )
                                                )}
                                          </select>
                                          {currentActivitytype?.length ===
                                            0 && (
                                              <div className="error-message-cme-hours">
                                                <span className="padding_top_5_px">
                                                  <ErrorIcon />{" "}
                                                  {"This field is required"}
                                                </span>
                                              </div>
                                            )}
                                        </div>

                                        <div className="mostRecent-box-left-div">
                                          <span className="cme-hours-label">
                                            Completion Date
                                          </span>
                                          <MyDatePicker
                                            onChange={handleNewDateChange}
                                            defaultValue={new Date(currentDate)}
                                            disableFutureDates
                                            required
                                            className={
                                              dayjs(currentDate).utc() ===
                                                null ||
                                                dayjs(currentDate).utc() >
                                                dayjs(new Date()).utc()
                                                ? "most-rec-activity self-reported-date  SelfReported-date-control error-cme-topic-hours-box-date width-100-perc"
                                                : " most-rec-activity self-reported-date SelfReported-date-control  width-100-perc"
                                            }
                                          />
                                          {dayjs(currentDate).utc() >
                                            dayjs(new Date()).utc() && (
                                              <div className="error-message-cme-hours">
                                                <span className="padding_top_5_px">
                                                  <ErrorIcon />{" "}
                                                  {"Date must be in the past"}
                                                </span>
                                              </div>
                                            )}
                                          {currentDate.trim().length == 0 && (
                                            <div className="error-message-cme-hours">
                                              <span className="padding_top_5_px">
                                                <ErrorIcon />{" "}
                                                {"This field is required"}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )}


                                  <div className={item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id ? "dashboard-content-flex-wrapper" : ""} style={item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id ? { display: 'flex', width: '100%', alignItems: 'stretch' } : {}}>
                                    <div className="unclaim-columnFirst">
                                      <div className="claim-cme-box">
                                        <div className="cme-hours-box">
                                          <div className="cme-hours-label">
                                            CME Hours
                                          </div>

                                          <input
                                            value={claimCMEHours.toString()}
                                            onChange={(event) =>
                                              onChangeCMEHoursText(event, item.Host)
                                            }
                                            type="text"
                                            onBlur={(event) =>
                                              roundUpClaimedHours(event, item.Host)
                                            }
                                            className={
                                              item.CME_Tracking_Status_Id === Finalized_CME_Tracking_Status_Id
                                                ? "cme-hours-input-box float_left input-disable"
                                                : showLeftHandTopicHoursValid &&
                                                  (item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id
                                                    ? (claimCMEHours === "0" || claimCMEHours === "")
                                                    : (parseFloat(claimCMEHours) > remainingHoursToClaim || claimCMEHours === "0" || claimCMEHours === ""))
                                                  ? "cme-hours-input-box error-cme-topic-hours-box float_left"
                                                  : "cme-hours-input-box float_left"
                                            }
                                          />
                                          {item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id && (
                                            <span className="cme-out-of-max-hours-span padding_left_5_px">
                                              out of{" "}
                                              <label className="unclaim-bold-max-hours">
                                                {" "}
                                                {remainingHoursToClaim}{" "}
                                              </label>
                                            </span>
                                          )}

                                          {showLeftHandTopicHoursValid &&
                                            item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id &&
                                            parseFloat(claimCMEHours) >
                                            remainingHoursToClaim ? (
                                            <div className="error-message-cme-hours display_table_row">
                                              <span>
                                                <ErrorIcon /> Cannot exceed Max
                                                CME Hours
                                              </span>
                                            </div>
                                          ) : showLeftHandTopicHoursValid &&
                                            (claimCMEHours === "0" ||
                                              claimCMEHours === "") ? (
                                            <div className="error-message-cme-hours display_table_row">
                                              <span>
                                                <ErrorIcon />
                                                This field is required
                                              </span>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>

                                      {(item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id) && (
                                        <>
                                          <div
                                            className="paddingTop_50_px"
                                            style={{
                                              minHeight: "45px",
                                              float: "left",
                                              width: "100%",
                                              textAlign: 'left'
                                            }}
                                          >
                                            {(item.CertificateUrl &&
                                              item.CertificateUrl.lastIndexOf(
                                                "."
                                              ) &&
                                              item.CertificateUrl.lastIndexOf(
                                                "."
                                              ).toString().length > 0) ||
                                              UploadedCertificateUrl.length >
                                              0 ? (
                                              <div className="selfReported-box-left-fileupload-div">
                                                <DeleteSelfReportedBlob
                                                  onSubmit={deleteSelfReportedBlob(
                                                    item.CertificateUrl
                                                  )}
                                                />

                                                <span
                                                  onClick={(ev) =>
                                                    getBlobAndDisplay(
                                                      ev,
                                                      item.CertificateUrl
                                                    )
                                                  }
                                                  className="claim-cme-certificate-url"
                                                >
                                                  {UploadedCertificateUrl.length >
                                                    0
                                                    ? UploadedCertificateUrl
                                                    : item.CertificateUrl?.substring(
                                                      item.CertificateUrl.lastIndexOf(
                                                        "/"
                                                      ) + 1
                                                    )}
                                                </span>
                                              </div>
                                            ) : (
                                              <form style={{ float: 'left' }} action="#">
                                                <>
                                                  <label htmlFor="file">
                                                    <label
                                                      htmlFor="file"
                                                      data-analytics="Upload File"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="transcript-cme-heading-right-text"
                                                    >
                                                      <FileUploadOutlined
                                                        style={{
                                                          verticalAlign:
                                                            "bottom",
                                                        }}
                                                      />{" "}
                                                      Upload Certification{" "}
                                                    </label>
                                                    <span className="selfReported-box-left-fileupload-filename">
                                                      {" "}
                                                      {
                                                        UploadedCertificateUrl
                                                      }{" "}
                                                    </span>
                                                  </label>

                                                  <input
                                                    id="file"
                                                    onChange={(event) =>
                                                      fileBrowseHandler(event)
                                                    }
                                                    type="file"
                                                    className="display-none"
                                                  />

                                                  <div
                                                    className="padding_left_25_px"
                                                    style={{
                                                      textAlign: 'left',
                                                      padding: '0',
                                                      color: invalidFileMessage
                                                        ? "red"
                                                        : "",
                                                    }}
                                                  >
                                                    (Max file size 5MB. Only .png, .jpg, .jpeg, .pdf, .doc, .docx files are allowed)
                                                  </div>
                                                </>
                                              </form>
                                            )}
                                          </div>
                                        </>
                                      )}
                                      <div
                                        style={{
                                          marginTop: "auto",
                                          marginBottom: "-25px",
                                          textAlign: 'left'
                                        }}
                                      >
                                        <DeleteSelfReportedActivity
                                          onSubmit={onDeleteSelfActivityClick(
                                            item.Id,
                                            item.CertificateUrl,
                                            index,
                                          )}
                                        />
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        marginLeft: true ? "" : "56px",
                                      }}
                                      className="unclaim-columnfirst-border-div"
                                    ></div>
                                    <div
                                      className={
                                        true
                                          ? "unclaim-columnSecond width_67_percent"
                                          : "unclaim-columnSecond width_97_percent"
                                      }
                                    >
                                      <div className="claim-cme-box">
                                        {/*will loop from here to showw multiple rows on click of Add Topic link */}
                                        {topicInfo
                                          .sort((x: any, y: any) => {
                                            if (x.IsValidAMAPRATopic && !y.IsValidAMAPRATopic) return -1;
                                            if (!x.IsValidAMAPRATopic && y.IsValidAMAPRATopic) return 1;

                                            // Sort by isCreditType
                                            const xIsCredit = cmeTopicList.find(item => item.Id === x.TopicId)?.isCreditType;
                                            const yIsCredit = cmeTopicList.find(item => item.Id === y.TopicId)?.isCreditType;
                                            return (yIsCredit ? 1 : 0) - (xIsCredit ? 1 : 0);
                                          })
                                          .map(
                                            (
                                              topicInfoDetails: iTopicInfo,
                                              iIndex: number
                                            ) =>
                                              topicInfoDetails.TopicId !== None_Topic_Id && (
                                                <div
                                                  key={topicInfoDetails.NewUID}
                                                  className="cme-add-topics-box"
                                                >
                                                  <div
                                                    className={
                                                      true
                                                        ? "cme-dv-topic width_39_percent"
                                                        : "cme-dv-topic width_45_percent"
                                                    }
                                                  >
                                                    <div className="cme-hours-label">
                                                      Topic
                                                    </div>
                                                    <div className="width_90_percent">
                                                      <select
                                                        required
                                                        onChange={(event) =>
                                                          onChangeAddedTopicDetails(
                                                            event,
                                                            iIndex,
                                                            "TopicId"
                                                          )
                                                        }
                                                        value={topicInfoDetails.TopicId?.toString()}
                                                        className={
                                                          topicInfoDetails.IsValidAMAPRATopic &&
                                                            item.CME_Tracking_Status_Id !==
                                                            SelfReported_CME_Tracking_Status_Id && item.Host !== "ABEM"
                                                            ? "input-disable cme-topic-input-box"
                                                            : !topicInfoDetails.IsValidTopicName
                                                              ? "cme-topic-input-box error-cme-topic-hours-box"
                                                              : "cme-topic-input-box "
                                                        }
                                                      >
                                                        {(item.Host === "ABEM") || (item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id) ? ([

                                                          ...cmeTopicList
                                                            .filter((topic) =>
                                                              topic.Id !== None_Topic_Id &&
                                                              (topic.Id === topicInfoDetails.TopicId || topic.ShowFieldOnUI === true || topic.isCreditType === true)
                                                            )
                                                            .sort((a, b) => {
                                                              // Credit types first
                                                              return (b.isCreditType ? 1 : 0) - (a.isCreditType ? 1 : 0);
                                                            }).sort((a, b) => (a.Id === -1 ? -1 : b.Id === -1 ? 1 : 0))
                                                        ].map((topic) => (
                                                          <option key={topic.Id} value={topic.Id}>
                                                            {topic.Name}
                                                          </option>
                                                        ))
                                                        ) : (
                                                          cmeTopicList
                                                            .filter((ele) =>
                                                              ele.Id === topicInfoDetails.TopicId ||
                                                              (ele.Id !== None_Topic_Id && ele.ShowFieldOnUI === true || (ele.Host === "ABEM" && ele.isCreditType === true))
                                                            )
                                                            .sort((a, b) => {
                                                              // Credit types first
                                                              return (b.isCreditType ? 1 : 0) - (a.isCreditType ? 1 : 0);
                                                            }).sort((a, b) => (a.Id === -1 ? -1 : b.Id === -1 ? 1 : 0))
                                                            .map((item) => (
                                                              <option key={item.Id} value={item.Id}>
                                                                {item.Name}
                                                              </option>
                                                            ))
                                                        )}


                                                      </select>
                                                    </div>
                                                    {!topicInfoDetails.IsValidTopicName && (
                                                      <div className="error-message-cme-hours">
                                                        <span className="padding_top_5_px">
                                                          <ErrorIcon />
                                                          {topicInfoDetails.TopicId !==
                                                            -1
                                                            ? "Please choose a different topic"
                                                            : "This field is required"}
                                                        </span>
                                                      </div>
                                                    )}
                                                  </div>
                                                  <div
                                                    className={
                                                      true
                                                        ? "cme-dv-hours width_30_percent"
                                                        : "cme-dv-hours width_39_percent"
                                                    }
                                                  >
                                                    <div className="cme-hours-label">
                                                      Hours
                                                    </div>
                                                    <div className="width_99_percent">
                                                      <input
                                                        required
                                                        value={
                                                          topicInfoDetails.TopicHours
                                                        }
                                                        onChange={(event) =>
                                                          onChangeAddedTopicDetails(
                                                            event,
                                                            iIndex,
                                                            "TopicHours"
                                                          )
                                                        }
                                                        onBlur={(event) =>
                                                          roundUpTopicHours(
                                                            event,
                                                            iIndex,
                                                            "TopicHours"
                                                          )
                                                        }
                                                        className={
                                                          topicInfoDetails.IsValidAMAPRATopic &&
                                                            item.CME_Tracking_Status_Id !==
                                                            SelfReported_CME_Tracking_Status_Id && item.Host !== "ABEM"
                                                            ? "input-disable cme-topic-hours-box"
                                                            : topicInfoDetails.IsValidTopicHours
                                                              ? "cme-topic-hours-box"
                                                              : "cme-topic-hours-box error-cme-topic-hours-box"
                                                        }
                                                      />
                                                      {!topicInfoDetails.IsValidTopicHours && (
                                                        <div className="error-message-cme-hours">
                                                          <span className="padding_top_5_px">
                                                            <ErrorIcon />
                                                            {/* YT: Condition added for CME Hours and Hours */}
                                                            {topicInfoDetails.TopicHours ===
                                                              "" ||
                                                              parseFloat(
                                                                topicInfoDetails.TopicHours
                                                              ) === 0
                                                              ? "This field is required"
                                                              : parseFloat(
                                                                topicInfoDetails.TopicHours
                                                              ) >
                                                                parseFloat(
                                                                  claimCMEHours
                                                                )
                                                                ? "Cannot exceed Claim Hours"
                                                                : ""}
                                                          </span>
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                  <span
                                                    className={
                                                      true
                                                        ? "cme-right-layout width_16_percent"
                                                        : "cme-right-layout width_11_percent"
                                                    }
                                                  >
                                                    {true &&
                                                      item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id &&
                                                      parseFloat(claimCMEHours) >
                                                      0 && (
                                                        <span className="cme-out-of-max-hours-span">
                                                          out of{" "}
                                                          <label className="unclaim-bold-max-hours">
                                                            {" "}
                                                            {claimCMEHours}{" "}
                                                          </label>
                                                        </span>
                                                      )}
                                                    {false && (
                                                      <span className="padding_left_50_px cme-out-of-max-hours-span ">
                                                        out of{" "}
                                                        <label className="unclaim-bold-max-hours">
                                                          {" "}
                                                          {claimCMEHours}{" "}
                                                        </label>
                                                      </span>
                                                    )}
                                                  </span>
                                                  {(
                                                    item.Host === "ABEM" ||
                                                    item.CME_Tracking_Status_Id === SelfReported_CME_Tracking_Status_Id ||
                                                    (!topicInfoDetails.IsValidAMAPRATopic &&
                                                      item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id)
                                                  ) && (
                                                      <div
                                                        className={
                                                          true
                                                            ? "cme-right-layout-delete-icon display_flex"
                                                            : "cme-right-layout-delete-icon display_initial"
                                                        }
                                                      >
                                                        <div className="CMETopicDelelteButton">
                                                          <DeleteTopic
                                                            onBlur={
                                                              setAddTrnascriptButtonState
                                                            }
                                                            onSubmit={onSubmit(
                                                              topicInfoDetails.NewUID,
                                                              iIndex,
                                                              topicInfoDetails.RecordID,
                                                              item.CME_Tracking_Status_Id,
                                                              index
                                                            )}
                                                          />
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>
                                              )
                                          )}

                                        <div className="claim-cme-heading claim-cme-heading-right-text">
                                          <div className="transcript_add_topic_div">
                                            <span
                                              style={{ cursor: "pointer" }}
                                              onClick={(event) =>
                                                onAddTopicInfo(event, item)
                                              }
                                              data-analytics="Add Topic"
                                            >
                                              {" "}
                                              Add Topic
                                            </span>
                                          </div>
                                        </div>

                                        {
                                          // topicInfo && topicInfo.length > 0 &&
                                          <div
                                            className="divAddTopicButtons"
                                            style={{
                                              marginTop: "auto",
                                              paddingTop: "10px"
                                            }}
                                          >
                                            {item.CME_Tracking_Status_Id !== SelfReported_CME_Tracking_Status_Id &&
                                              !props_Input && (
                                                <Container
                                                  modalFor="UnclaimActivity"
                                                  triggerText="UnclaimActivity"
                                                  modalHeaderText="Are you sure?"
                                                  //StatusEnum = {"Active": 1,"Confirmed":3, "Pending":4, "Manual":5,"Finalized" : 6};
                                                  onSubmit={(ev: any) => {
                                                    onUnclaimActivityClick(
                                                      ev,
                                                      item.Id,
                                                      4,
                                                      index,
                                                      item
                                                    );
                                                  }}
                                                />
                                              )}
                                            <Button
                                              variant="outlined"
                                              onClick={() => {
                                                const doCancel = () => {
                                                  setCurrent("");
                                                  item.IsExpand = false;
                                                  setSelectedRowIndex(index);
                                                  setFormDirty(false);
                                                };
                                                if (formDirty) {
                                                  pendingCancelRef.current = doCancel;
                                                  setLeaveDialogOpen(true);
                                                } else {
                                                  doCancel();
                                                }
                                              }}
                                              className="cancel-transcript-button cancel-transcript-button-width color_white text_transform_none"
                                            >
                                              <b color="#1976D2"> Cancel</b>
                                            </Button>

                                            <Button
                                              onClick={(event) => {
                                                onAddTranscriptDetails(event, item)
                                                setSelectedRowIndex(index);
                                              }
                                              }
                                              variant="contained"
                                              className={
                                                props_Input
                                                  ? "add-transcript-button text_transform_none model-submit-button-border"
                                                  : "add-transcript-button text_transform_none save-transcript-button-width model-submit-button-border"
                                              }
                                              data-analytics={props_Input ? "Add To Transcript" : "Save To Transcript"}                                          >
                                              <b className="color_white">
                                                {props_Input
                                                  ? "Add To Transcript"
                                                  : "Save"}
                                              </b>
                                            </Button>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </>)}
                                </div>
                              ) : null}
                            </div>
                          );
                        })}
                      </List>
                      {!props_Input && (
                        <div className="note">
                          <span className="text-color-red">*</span>
                          These activities are self-reported, not accredited by ACEP, and will not be reported to state licensing boards. Certificates are available for ACEP accredited activities only.
                        </div>
                      )}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </>
              )}
            </div>
            <div style={{ display: "none" }}>
              <Container
                modalFor={"Certificates"}
                triggerText={"Certificates"}
                modalHeaderText={
                  selectedABEMTransRecordList.length > 0
                    ? "Certificates not found for following activities"
                    : "Certificates not found for following self-reported activities"
                }
                customBtnRef={inputElement}
                onSubmit={onSubmitCertificates}
                inputProperties={{
                  modalData: lstSelfReportedNotAvailableCertificates,
                  bDisableExportCertButton: bDisableExportCertButton,
                  showExportButton: bToShowExportCertButton,
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Stack className="stackMsg" spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openAlertMsg}
          autoHideDuration={5000}
          onClose={() => setOpenAlertMsg(false)}
        >
          <Alert severity={errorMsg.length > 0 ? "error" : "info"} sx={{ width: "100%" }}>
            {msg}
          </Alert>
        </Snackbar>
        {/* Both banners anchor at the same bottom-left corner and stack there — the newest one
            takes the bottom-most slot, and any banner already showing shifts up by one slot
            (accreditationToastOffsetPx) with padding between them, rather than sitting side by
            side or overlapping directly on top of each other. */}
        <Snackbar
          open={parsAlertOpen}
          autoHideDuration={6000}
          onClose={() => { setParsAlertOpen(false); popAccreditationToast('pars'); }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          style={{ bottom: `${24 + accreditationToastOffsetPx('pars')}px` }}
        >
          <Alert severity={parsAlertSeverity} sx={{ width: "100%" }}>
            {parsAlertMsg}
          </Alert>
        </Snackbar>
        <Snackbar
          open={ceBrokerAlertOpen}
          autoHideDuration={6000}
          onClose={() => { setCeBrokerAlertOpen(false); popAccreditationToast('cebroker'); }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          style={{ bottom: `${24 + accreditationToastOffsetPx('cebroker')}px` }}
        >
          <Alert severity={ceBrokerAlertSeverity} sx={{ width: "100%" }}>
            {ceBrokerAlertMsg}
          </Alert>
        </Snackbar>
      </Stack>
      {FEATURE_ACCREDITATION_ENABLED && parsModalOpen && (() => {
        const M = PARSModal as any;
        return (
          <M
            modalFor="PARSConsent"
            modalHeaderText="Submit to State Licensing Boards?"
            closeModal={handlePARSModalClose}
            onSubmit={handlePARSAccept}
            closeModalCustomClick={handlePARSDecline}
            onClickOutside={() => {}}
            onKeyDown={() => {}}
            modalRef={null}
            buttonRef={null}
          />
        );
      })()}
      {FEATURE_ACCREDITATION_ENABLED && profileModalOpen && (() => {
        const M = PARSModal as any;
        return (
          <M
            modalFor="UpdateProfile"
            modalHeaderText="Update Profile Information"
            closeModal={() => { setProfileModalOpen(false); activityWarningContinueRef.current?.(); activityWarningContinueRef.current = null; }}
            onSubmit={() => { window.open(CMEAccountURLForProfile, '_blank', 'noopener,noreferrer'); setProfileModalOpen(false); activityWarningContinueRef.current?.(); activityWarningContinueRef.current = null; }}
            closeModalCustomClick={() => { setProfileModalOpen(false); activityWarningContinueRef.current?.(); activityWarningContinueRef.current = null; }}
            onClickOutside={() => {}}
            onKeyDown={() => {}}
            modalRef={null}
            buttonRef={null}
            inputProperties={{ missingFields: missingProfileFields }}
          />
        );
      })()}
      {deadlineWarningOpen && (() => {
        const M = PARSModal as any;
        return (
          <M
            modalFor="DeadlineWarning"
            modalHeaderText="Action Required: Claim Your CME Credits Soon"
            closeModal={() => setDeadlineWarningOpen(false)}
            onSubmit={() => setDeadlineWarningOpen(false)}
            closeModalCustomClick={() => setDeadlineWarningOpen(false)}
            onClickOutside={() => {}}
            onKeyDown={() => {}}
            modalRef={null}
            buttonRef={null}
            inputProperties={{
              approachingItems: approachingDeadlineItems.map((it: any) => ({
                ...it,
                daysRemaining: getDaysRemaining(it.FormatActivityEndDate)
              }))
            }}
          />
        );
      })()}
      <LeavePageDialog
        open={leaveDialogOpen}
        onLeave={() => { setLeaveDialogOpen(false); if (pendingCancelRef.current) { pendingCancelRef.current(); pendingCancelRef.current = null; } }}
        onStay={() => setLeaveDialogOpen(false)}
      />
      <Prompt when={formDirty} message="unsaved" />
    </>
  );
}


export default function ClaimUnclaimCME(source: any) {
  let enableObject = { opacity: 0.4, pointer: "none" };

  const [claimeStyles, setclaimeStyles] = useState(enableObject);
  const [spinner, setSpinner] = useState(true);
  const [propsSource, setPropsValue] = useState({ previous: "", current: "" });

  let propSource = source.source;

  React.useEffect(() => {
    if (source.source !== propsSource.previous) {
      setPropsValue({ previous: source.source, current: source.source });
    }
    if (!spinner) {
      enableObject = {
        opacity: 1,
        pointer: "auto",
      };
    }

    setclaimeStyles(enableObject);
  }, [spinner]);

  return (
    <>
      {spinner ? <div className="spinner"></div> : null}

      <ClaimUnclaimCMEDashboard
        claimeStyles={claimeStyles}
        spinner={spinner}
        showSpinner={(toShow: boolean) => {
          setSpinner(toShow);
        }}
        propsSource={propSource}
      />

    </>
  );
}
